// Solano Essence i18n — fr
const fr = {
  "food": {
    "gramsTab": "Grammes",
    "pieces": "Pièces",
    "sizeSmall": "petit",
    "sizeMedium": "moyen",
    "sizeLarge": "grand",
    "barcodeNotFoundAddManually": "Produit introuvable — ajoute-le manuellement",
    "notFound": "Produit introuvable",
    "labelUnreadable": "Étiquette illisible, réessaie avec plus de lumière",
    "labelProduct": "Produit depuis l'étiquette",
    "labelError": "Lecture de l'étiquette échouée",
    "manualAdd": {
      "needBasics": "Le nom et le code-barres sont requis",
      "saved": "Produit enregistré ✓",
      "labelAnalyzed": "Étiquette lue ✓ — vérifie les valeurs",
      "labelError": "Étiquette illisible. Essaie une photo plus nette.",
      "title": "Ajouter ce produit manuellement",
      "subtitle": "Ce code-barres n'est pas encore dans la base — enregistre-le une fois et le prochain scan sera instantané.",
      "labelAiTitle": "Remplir avec l'IA ✨",
      "labelAiSubtitle": "Photographie l'étiquette nutritionnelle — l'IA lit les kcal et macros et remplit le formulaire pour toi.",
      "labelCamera": "Prendre une photo",
      "labelUpload": "Importer une photo",
      "labelAnalyzing": "L'IA lit l'étiquette…",
      "productPhoto": "Photo du produit",
      "productPhotoRetake": "Reprendre la photo",
      "productPhotoAdd": "Ajouter une photo",
      "barcode": "Code EAN",
      "name": "Nom du produit",
      "namePlaceholder": "ex. Yaourt grec nature",
      "brand": "Marque (optionnel)",
      "brandPlaceholder": "ex. FAGE",
      "per100g": "Valeurs pour 100 g",
      "kcal": "Calories",
      "protein": "Protéines",
      "carbs": "Glucides",
      "fat": "Lipides",
      "sugar": "Sucres",
      "fiber": "Fibres",
      "satFat": "Graisses sat.",
      "salt": "Sel",
      "hint": "Recopie les valeurs de l'étiquette nutritionnelle. Tu peux laisser vides les champs inutiles.",
      "saveAndUse": "Enregistrer et utiliser"
    },
    "favRemoved": "Retiré des favoris",
    "favAdded": "Ajouté aux favoris",
    "customName": "Nom",
    "customCreated": "Aliment créé",
    "deleteConfirm": "Supprimer cet aliment ?",
    "customDeleted": "Aliment supprimé",
    "noFavYet": "Pas encore de favoris. Touche le cœur sur un aliment pour l'enregistrer.",
    "noCustomYet": "Pas encore d'aliments personnalisés. Crée le premier.",
    "noRecipesYet": "Aucune recette trouvée.",
    "noRecentYet": "Pas encore d'aliments récents. Ajoute ton premier repas !",
    "minLettersHint": "Tape au moins 2 lettres pour chercher dans la base.",
    "title": "Trouver un aliment",
    "description": "Cherche par nom ou scanne le code-barres d'un produit",
    "nameSaved": "Nom du produit enregistré — les prochains scans l'afficheront",
    "searchPh": "banane, pâtes complètes, yaourt grec…",
    "per100g": "pour 100 g",
    "perPortion": "par portion",
    "createCustom": "Nouvel aliment",
    "searchInDbCta": "Chercher « {q} » dans la base Solano",
    "detailBadge": "DÉTAIL",
    "aiEstimateTip": "Valeurs nutritionnelles estimées par l'IA : vérifie avant d'enregistrer.",
    "aiBadge": "ESTIMATION IA",
    "removeFav": "Retirer des favoris",
    "addToFav": "Ajouter aux favoris",
    "backToResults": "Retour",
    "servingsN": "{n} portions",
    "servings": "portions",
    "portion": "portion",
    "recipeIngredients": "Ingrédients",
    "recipeSteps": "Préparation",
    "quantityConsumed": "Quantité consommée",
    "yourPortion": "Ta portion",
    "sugar": "Sucres",
    "fiber": "Fibres",
    "satFat": "AG saturés",
    "salt": "Sel",
    "ofCarbs": "dont",
    "ofFat": "dont",
    "lightSugarShort": "Su",
    "lightFatShort": "G",
    "lightSaltShort": "Se",
    "altTitle": "Alternative plus saine ?",
    "altCta": "3 suggestions",
    "altEmpty": "Aucune alternative verte adaptée trouvée.",
    "lightLow": "faible",
    "lightMid": "moyen",
    "lightHigh": "élevé",
    "lightBasis": "pour 100 g",
    "noDetails": "Pas de données sur les sucres, fibres, graisses saturées et sel pour ce produit.",
    "addToMeal": "Ajouter au repas",
    "cancel": "Annuler",
    "editCustom": "Modifier l'aliment",
    "customBrand": "Marque (opt.)",
    "customNotes": "Notes (opt.)",
    "save": "Enregistrer",
    "byBarcode": "Code-barres",
    "torch": "Lampe",
    "pinchZoomHint": "Pince avec deux doigts pour zoomer.",
    "zoom": "Zoom",
    "aimAtBarcode": "Pointe la caméra vers le code-barres du produit",
    "scannerFocusHint": "S'il ne lit pas, touche le code-barres pour faire la mise au point.",
    "scanWithCamera": "Scanner avec la caméra",
    "camTip": "Astuce : touche l'icône ↗ en haut pour ouvrir l'app hors de l'aperçu et accorder l'autorisation.",
    "camTipNative": "Astuce : autorise l'accès à la caméra dans Paramètres → Applications → Solano Essence → Autorisations → Caméra, puis réessaie.",
    "or": "ou",
    "labelOcrTitle": "Code-barres illisible ?",
    "labelOcrBody": "Prends une photo de l'étiquette nutritionnelle — l'IA lit les valeurs",
    "labelOcrCameraCta": "Prendre une photo",
    "labelOcrGalleryCta": "Galerie",
    "noBarcodeInImage": "Aucun code-barres détecté sur la photo",
    "enterCode": "Saisir le code",
    "startingCamera": "Démarrage de la caméra…",
    "camError": "Impossible d'ouvrir la caméra",
    "pointBarcode": "Pointe la caméra vers le code-barres du produit",
    "pickPhoto": "Prendre ou choisir une photo",
    "orEnterManually": "Ou saisis le code manuellement :",
    "rescan": "Scanner à nouveau"
  },
  "webGate": {
    "title": "Utilise l'app iPhone",
    "body": "Solano Essence vit exclusivement dans l'app iPhone. Ouvre l'app sur ton téléphone pour continuer — ton coach t'y attend."
  },
  "clientLang": {
    "preferred": "Langue préférée"
  },
  "clientHero": {
    "status": {
      "excellent": "Excellente progression",
      "good": "En bonne voie",
      "attention": "À surveiller",
      "unknown": "Nouveau client"
    },
    "coachAi": "Coach AI",
    "aiAnalysis": "Analyse IA",
    "aiError": "Échec de l'analyse IA",
    "copied": "Message copié",
    "sendAsFeedback": "Envoyer comme feedback",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "weeklyAdherence": "Adhérence hebdomadaire",
    "avg": "Moy :",
    "strengths": "Points forts",
    "toImprove": "À améliorer",
    "suggestedMessage": "Message suggéré",
    "kpi": {
      "weight": "Poids",
      "calories": "Score",
      "protein": "Protéines",
      "sleep": "Sommeil",
      "hrv": "HRV",
      "steps": "Pas",
      "water": "Eau",
      "workouts": "Séances"
    },
    "trends": {
      "title": "Tendances",
      "subtitle": "Derniers {days} jours",
      "tabs": {
        "weight": "Poids",
        "sleep": "Sommeil",
        "kcal": "Calories"
      },
      "avg": "Moy",
      "target": "Cible",
      "empty": "Aucune donnée sur cette période",
      "units": {
        "kg": "kg",
        "hours": "h",
        "kcal": "kcal"
      },
      "ranges": {
        "d7": "7j",
        "d14": "14j",
        "d30": "30j"
      }
    },
    "week": "sem."
  },
  "notifBell": {
    "achievements": "Succès",
    "levelUp": "Niveau {level} atteint — « {name} »",
    "streak": "Série de {days} jours ! +{points} SP",
    "badge": "Nouveau badge : {name}",
    "goals": {
      "water_goal": "Objectif eau atteint",
      "steps_goal": "Objectif de pas atteint",
      "sleep_7h": "7 h de sommeil atteintes",
      "diary_complete": "Journal complet (3+ repas)",
      "plate_check_80": "Assiette équilibrée réussie"
    },
    "title": "Notifications",
    "empty": "Aucune nouvelle notification",
    "openFriends": "Ouvrir les amis"
  },
  "offline": {
    "savedOffline": "Pas de réseau – repas enregistré sur l'appareil, il sera envoyé automatiquement",
    "synced": "{count} repas envoyé(s)",
    "syncFailed": "{count} repas n'ont pas pu être envoyés",
    "pendingTitle": "{count} repas en attente de connexion",
    "pendingHint": "Ils seront ajoutés au journal automatiquement dès que le réseau revient.",
    "sendNow": "Envoyer maintenant",
    "stillOffline": "Toujours pas de connexion – on réessaie",
    "waiting": "En attente de connexion"
  },
  "voicePrivacy": {
    "title": "Que devient ma voix ?",
    "pillNotStored": "La voix n'est pas enregistrée",
    "pillStored": "Le message vocal est enregistré",
    "introDictation": "La dictée ne fait que transformer ta voix en texte.",
    "dict1": "L'enregistrement est transmis chiffré et sert uniquement à produire du texte. Seul ce texte est conservé – comme si tu l'avais tapé. Tu peux le vérifier et le modifier avant d'enregistrer.",
    "dict2": "Le fichier audio est supprimé immédiatement après la transcription. Il n'atteint ni la base de données ni les sauvegardes.",
    "dict3": "Le micro n'est actif que pendant que tu enregistres volontairement. Aucune écoute en arrière-plan.",
    "introStored": "Ce message vocal est destiné à ta conseillère ou ton conseiller en nutrition.",
    "msg1": "L'enregistrement est conservé avec l'entrée – comme un message de chat – pour que ton coach puisse l'écouter.",
    "msg2": "Seuls toi et ton coach connecté pouvez l'écouter. Il n'est pas envoyé à une IA ni transcrit.",
    "msg3": "Supprime-le à tout moment en remplaçant la réponse, en supprimant l'entrée ou ton compte.",
    "never": "Voix, photos et chats ne servent jamais à entraîner une IA et ne sont jamais transmis à des régies publicitaires.",
  },
  "dailySummary": {
    "sourceManual": "Manuel",
    "pickTheme": "Choisir le style",
    "title": "Ta journée",
    "today": "Aujourd'hui",
    "sleep": "Sommeil",
    "steps": "Pas",
    "water": "Eau",
    "kcal": "Kcal",
    "workout": "Séance",
    "goals": "Objectifs",
    "missionsAllDone": "Missions terminées ! 🎉",
    "missionsAllDoneSub": "+{n} SP bonus du jour",
    "download": "Télécharger ma journée",
    "downloaded": "Image enregistrée",
    "shareTitle": "Ma journée Solano",
    "share": "Partager",
    "longPressToSave": "Maintiens l'image appuyée pour l'enregistrer dans Photos",
    "previewHint": "Enregistre l'image ou partage-la directement",
    "shareFailedHint": "Partage impossible – maintiens l'image appuyée pour l'enregistrer",
    "mealsToday": "Repas d'aujourd'hui",
    "noMeals": "Aucun repas enregistré aujourd'hui",
    "pointsToday": "Points aujourd'hui",
    "coachMessage": "Ton coach dit",
    "brand": "Ta journée bien-être",
    "defaultMotivation": "Un jour à la fois. Petits pas, grandes victoires. 💪",
    "themeLabel": "Thème",
    "themes": {
      "bright_morning": "Matin lumineux",
      "golden_hour": "Heure dorée",
      "deep_teal": "Teal profond",
      "berry_night": "Nuit baies"
    },
    "waterQuickTitle": "Ajouter de l'eau",
    "waterCustomPlaceholder": "Saisir des ml…"
  },
  "coach": {
    "title": "Coach du jour",
    "today": "Solano IA",
    "refresh": "Actualiser"
  },
  "mascots": {
    "section": "Moments mascotte",
    "title": "Ta collection",
    "steps": "Objectif pas",
    "stepsHint": "Atteins ton objectif de pas",
    "training": "Entraînement",
    "trainingHint": "Termine un entraînement",
    "water": "2L d'eau",
    "waterHint": "Bois 2 litres en une journée",
    "sleep": "Objectif sommeil",
    "sleepHint": "Atteins ton objectif de sommeil",
    "unlockedCount": "{n} sur {total} débloqués"
  },
  "nutriscore": {
    "info": {
      "title": "Qu'est-ce que le Nutri-Score ?",
      "body": "Le Nutri-Score sert de repère et compare des produits similaires entre eux. Il n'indique pas à lui seul si un aliment est sain ou malsain.",
      "hint": "A = valeurs nutritives plus équilibrées pour 100 g. E = ingrédients intenses comme sucre, sel ou acides gras saturés."
    }
  },
  "solano": {
    "label": "Évaluation Solano",
    "tier": {
      "very_good": "Très bon choix",
      "good": "Bon choix",
      "ok": "Correct",
      "mindful": "À consommer consciemment"
    },
    "hint": {
      "bio": "Qualité bio",
      "wholegrain": "Complet",
      "no_added_sugar": "Sans sucre ajouté",
      "less_fat": "Moins gras que le classique",
      "fried": "Frit — à utiliser avec parcimonie",
      "processed_meat": "Viande transformée — avec conscience",
      "whole_food": "Aliment entier",
      "mindful": "Occasionnellement",
      "watch_salt": "Attention au sel et aux graisses saturées",
      "hydrating": "Idéal pour s'hydrater"
    }
  },
  "mealBadges": {
    "excellent": "Excellent repas",
    "highProtein": "Riche en protéines",
    "highFiber": "Riche en fibres",
    "lightSnack": "Collation légère",
    "lowProtein": "Peu de protéines",
    "lowFiber": "Peu de légumes",
    "highSugar": "Trop de sucre",
    "highSalt": "Trop salé",
    "highSatFat": "Graisses saturées",
    "heavySnack": "Collation lourde"
  },
  "mealFilter": {
    "all": "Tous",
    "problems": "Uniquement problèmes",
    "warnings": "À améliorer",
    "counter": "{n} repas"
  },
  "adherence": {
    "title": "Chronologie d'adhérence",
    "subtitle": "Derniers {days} jours",
    "avg": "Moy :",
    "empty": "Aucune donnée"
  },
  "quickActions": {
    "chat": "Chat",
    "updatePlan": "Mettre à jour le plan",
    "writeFeedback": "Écrire un feedback",
    "noMealToComment": "Aucun repas sans feedback"
  },
  "voiceFood": {
    "tap": "Rechercher à la voix",
    "listening": "J'écoute…",
    "processing": "Transcription…",
    "tapToStop": "Toucher pour arrêter",
    "notSupported": "Ton navigateur ne prend pas en charge le micro",
    "micDenied": "Microphone refusé",
    "tooShort": "Audio trop court, réessaie",
    "notRecognized": "Je n'ai pas compris, réessaie",
    "error": "Échec de la transcription",
    "multiFound": "{n} aliments détectés",
    "multiHint": "Touche un élément pour le rechercher",
    "tapToSearch": "Touche pour rechercher",
    "multiAllDone": "{n} aliments enregistrés ✓",
    "moveTo": "Déplacer vers {name}",
    "moved": "Déplacé vers {name}"
  },
  "profileSetup": {
    "hint": "Dernière étape",
    "title": "Ton profil",
    "subtitle": "Nous avons besoin de quelques informations pour calculer automatiquement tes calories et macros journaliers.",
    "goalLabel": "Ton objectif",
    "activityLabel": "Niveau d'activité",
    "submit": "Calculer et continuer",
    "skip": "Passer pour l'instant",
    "savedOk": "Profil enregistré — calories calculées !",
    "privacyNote": "Tu peux modifier ces valeurs à tout moment depuis ton Profil.",
    "errAge": "Âge invalide (10-120)",
    "errHeight": "Taille invalide (100-250 cm)",
    "errWeight": "Poids invalide (30-300 kg)"
  },
  "onboarding": {
    "welcome": "Bienvenue",
    "title": "Comment veux-tu utiliser l'app ?",
    "subtitle": "Choisis ton rôle pour continuer. Tu peux toujours contacter le support pour le modifier.",
    "nutTitle": "Je suis le/la Nutritionniste",
    "nutDesc": "Gère tes clients, crée des plans alimentaires assistés par IA, suis les progrès et les rendez-vous.",
    "cliTitle": "Je suis un(e) Client(e)",
    "cliDesc": "Suis ton plan, note ton poids et tes mesures, enregistre tes repas, prends rendez-vous.",
    "inviteLabel": "Code d'invitation",
    "invitePlaceholder": "EX : A1B2C3D4",
    "linkMe": "Me relier",
    "inviteRequired": "Saisis le code d'invitation",
    "inviteInvalid": "Code invalide",
    "linkedOk": "Relié à ton/ta nutritionniste !",
    "soloOk": "Bienvenue ! Tu peux te relier à un(e) nutritionniste plus tard.",
    "yourCode": "Ton code d'invitation",
    "shareCodeDesc": "Partage ce code avec tes clients : ils l'utiliseront pour rejoindre ton cabinet.",
    "goToDash": "Aller au tableau de bord →",
    "clientOptionsTitle": "Comment veux-tu commencer ?",
    "clientOptionsDesc": "Tu peux te relier tout de suite à un(e) nutritionniste avec un code d'invitation, ou commencer en solo. Tu pourras te relier à tout moment depuis ton profil.",
    "recommended": "Recommandé",
    "withInviteTitle": "J'ai un code d'invitation",
    "withInviteDesc": "Ton/ta nutritionniste t'a fourni un code — connecte-toi à son cabinet.",
    "orNoCode": "Ou sans code",
    "soloTitle": "Commencer en solo",
    "soloDesc": "Commence à utiliser l'app tout de suite. Toutes les fonctions personnelles restent disponibles.",
    "soloFeat1": "Suivi des repas et macros",
    "soloFeat2": "Poids, mesures, photos de progression",
    "soloFeat3": "Journal alimentaire et recettes",
    "startSolo": "Commencer en solo",
    "canLinkLater": "Tu pourras te relier à un(e) nutritionniste à tout moment depuis ton profil."
  },
  "onboardingTutorial": {
    "skip": "Passer",
    "prev": "Retour",
    "next": "Suivant",
    "start": "Commencer",
    "loadError": "Impossible de charger le tutoriel",
    "profileButton": "Revoir le tutoriel",
    "slides": {
      "welcome": {
        "hint": "50% légumes · 25% protéines · 25% glucides",
        "title": "Ton voyage commence ici",
        "body": "Bienvenue sur Solano Essence. Une façon élégante de prendre soin de ton corps — une assiette à la fois."
      },
      "log": {
        "hint": "Voix · Photo IA · Recherche",
        "title": "Enregistre en un instant",
        "body": "Parle au micro, prends une photo ou cherche dans la base Solano de 5 000+ aliments."
      },
      "gamify": {
        "hint": "Séries · Missions · États de santé",
        "title": "Chaque bonne habitude compte",
        "body": "Gagne des Solano Points à chaque repas sain, entraînement et nuit de sommeil. Débloque des badges."
      },
      "sync": {
        "hint": "Automatique, silencieux, toujours frais",
        "title": "Synchronise ton corps",
        "body": "Connecte Google Fit, Apple Health ou ton wearable. Pas, sommeil et entraînements toujours à jour."
      },
      "start": {
        "hint": "Enregistre ton premier repas",
        "title": "Tu es prêt",
        "body": "Ton coach IA est à tes côtés. Chaque petit pas compte — commençons ensemble."
      }
    }
  },
  "rewards": {
    "navLabel": "Récompenses",
    "title": "Tes Récompenses",
    "subtitle": "Constance et bien-être, un jour à la fois",
    "totalSp": "Solano Points",
    "levelLabel": "Niveau",
    "nextLevel": "Prochain État",
    "spToNext": "{n} SP avant {name}",
    "maxLevel": "Niveau maximum atteint",
    "streakCurrent": "Jours consécutifs",
    "streakLongest": "Record personnel",
    "todaySp": "Gagnés aujourd'hui",
    "dailyMissions": "Missions du jour",
    "dailyMissionsSub": "Complète les 3 pour un bonus de {n} SP",
    "allCompletedBonus": "Bonus quotidien débloqué ! +{n} SP",
    "weeklyMissions": "Missions de la semaine",
    "weeklyMissionsSub": "Complète les 5 pour un bonus de {n} SP",
    "weeklyAllCompleted": "Bonus hebdomadaire débloqué ! +{n} SP",
    "weeklyRange": "Semaine du {start} au {end}",
    "store": "Boutique cosmétique",
    "storeSub": "SP disponibles : {n}",
    "buy": "Acheter",
    "purchased": "Acheté",
    "insufficientSp": "SP insuffisants",
    "confirmPurchase": "Acheter {name} pour {cost} SP ?",
    "purchaseSuccess": "🎉 Débloqué !",
    "spGained": "SP gagnés",
    "levelUpToast": "Nouveau niveau : {name} !",
    "levelUpTitle": "Niveau débloqué",
    "levelUpContinue": "Continuer",
    "personalizeTitle": "Personnalise ton profil",
    "personalizeHint": "Uniquement les cosmétiques achetés",
    "personalizeThemes": "Thème actif",
    "personalizeBadges": "Badges affichés (max 3)",
    "personalizeAnimations": "Animations",
    "themeDefault": "Pétrole (par défaut)",
    "categoryTheme": "Thème",
    "categoryBadge": "Badge exclusif",
    "categoryAnimation": "Animation",
    "itemNames": {
      "theme_forest": "Thème Forêt",
      "theme_ocean": "Thème Océan",
      "theme_sunset": "Thème Coucher de soleil",
      "theme_bianconero": "Noir & Or",
      "theme_nerazzurro": "Bleu & Noir",
      "theme_rossonero": "Rouge & Noir",
      "theme_azzurro": "Azur Italie",
      "theme_giallorosso": "Jaune & Rouge",
      "theme_tricolore": "Tricolore Italie",
      "theme_neon": "Néon Cyber",
      "theme_lavender": "Lavande Bien-être",
      "theme_rosegold": "Or Rose",
      "theme_matcha": "Matcha",
      "theme_midnight": "Minuit",
      "badge_early_bird": "Aube dorée",
      "badge_night_owl": "Chouette nocturne",
      "badge_gourmet": "Gourmet",
      "anim_confetti_gold": "Confettis dorés",
      "anim_progress_glow": "Lueur de progression"
    },
    "weeklyNames": {
      "wk_workouts_5": "5 séances",
      "wk_plates_5": "5 assiettes excellentes",
      "wk_sleep_6": "6 nuits > 7h",
      "wk_fiber_5": "5 jours avec 30g de fibres",
      "wk_steps_60k": "60 000 pas"
    },
    "syncFit": "Synchroniser Google Fit",
    "syncFitHint": "Aucun pas aujourd'hui — synchronise",
    "syncing": "Synchronisation…",
    "syncOk": "Données synchronisées",
    "syncFailed": "Échec de la synchronisation",
    "badges": "Badges",
    "earnedBadges": "{n} débloqués",
    "lockedBadges": "{n} à débloquer",
    "recentActivity": "Activité récente",
    "empty": "Aucun événement",
    "widgetTitle": "Progression",
    "widgetCta": "Ouvrir Récompenses",
    "viewAll": "Tout voir",
    "congratsBadge": "Nouveau badge !",
    "levelUp": "Nouvel état atteint !",
    "states": {
      "newStart": {
        "name": "Nouveau départ",
        "quote": "Chaque grand changement commence par un petit pas."
      },
      "inBalance": {
        "name": "En équilibre",
        "quote": "Tu construis des habitudes saines."
      },
      "activeWellness": {
        "name": "Bien-être actif",
        "quote": "Ton mode de vie s'améliore."
      },
      "steadyShape": {
        "name": "Forme constante",
        "quote": "La constance est ta force."
      },
      "totalEnergy": {
        "name": "Énergie totale",
        "quote": "Ton corps te remercie."
      },
      "eliteHealth": {
        "name": "Santé d'élite",
        "quote": "Tu as atteint un niveau supérieur."
      },
      "ambassador": {
        "name": "Ambassadeur",
        "quote": "Tu es un modèle de discipline."
      },
      "legend": {
        "name": "Légende",
        "quote": "L'excellence est devenue ton style de vie."
      },
      "master": {
        "name": "Maître",
        "quote": "Tu maîtrises tes habitudes – pas l'inverse."
      },
      "champion": {
        "name": "Champion",
        "quote": "La constance au plus haut niveau."
      },
      "inspiration": {
        "name": "Inspiration",
        "quote": "Ton parcours motive les autres."
      },
      "diamond": {
        "name": "Diamant",
        "quote": "Forgé sous pression, devenu incassable."
      },
      "titan": {
        "name": "Titan",
        "quote": "Ta discipline ne connaît aucune limite."
      },
      "olymp": {
        "name": "Olympe",
        "quote": "Tu joues dans ta propre ligue."
      },
      "immortal": {
        "name": "Immortel",
        "quote": "Tes habitudes sont faites pour durer toujours."
      }
    },
    "badgeNames": {
      "meals_30": "30 repas enregistrés",
      "meals_100": "100 repas enregistrés",
      "water_100_days": "100 jours hydratés",
      "steps_100k": "100k pas",
      "steps_1m": "1 million de pas",
      "workouts_50": "50 séances",
      "workouts_100": "100 séances",
      "sleep_30": "30 nuits de 7h",
      "streak_30": "30 jours d'affilée",
      "streak_100": "100 jours d'affilée",
      "first_month": "Premier mois",
      "first_year": "Première année",
      "protein_30": "30 jours protéines OK",
      "fiber_30": "30 jours fibres OK",
      "learn_streak_7": "Série d'apprentissage de 7 jours",
      "learn_streak_30": "Série d'apprentissage de 30 jours",
      "learn_correct_50": "50 bonnes réponses au quiz"
    },
    "missionNames": {
      "protein_bkfst30": {
        "title": "30g de protéines au petit-déj",
        "hint": "Œufs, yaourt grec ou whey au 1er repas."
      },
      "water_2l": {
        "title": "Bois 2 litres d'eau",
        "hint": "Un verre par heure pour rester dans le rythme."
      },
      "steps_8k": {
        "title": "8.000 pas",
        "hint": "30 min de marche + les escaliers."
      },
      "fiber_30g": {
        "title": "30g de fibres",
        "hint": "Légumes déj/dîner + fruits et légumineuses."
      },
      "sleep_7h": {
        "title": "7h de sommeil",
        "hint": "Éteins les écrans 30 min avant de dormir."
      },
      "workout_done": {
        "title": "Termine une séance",
        "hint": "Même 20 min activent métabolisme et humeur."
      },
      "log_all_meals": {
        "title": "Enregistre tous les repas",
        "hint": "Petit-déj, déj et dîner — au moins 3."
      },
      "plate_balanced": {
        "title": "Une assiette Solano équilibrée",
        "hint": "50% légumes, 25% protéines, 25% glucides."
      }
    },
    "actions": {
      "meal_log": "Repas enregistré",
      "meal_photo_bonus": "Photo du repas",
      "plate_check_80": "Assiette équilibrée vérifiée (80%+)",
      "plate_balanced": "Assiette équilibrée",
      "water_goal": "Objectif eau",
      "steps_goal": "Objectif pas",
      "workout_done": "Séance",
      "sleep_7h": "Nuit 7h+",
      "learn_pill": "Conseil lu",
      "diary_complete": "Journal complet",
      "streak_bonus": "Bonus série",
      "daily_bonus": "Bonus missions",
      "weekly_bonus": "Bonus hebdomadaire",
      "purchase": "Achat boutique"
    },
    "swapUsedTooltip": "Tu as déjà utilisé l'échange du jour",
    "swapTooltip": "Échange cette mission contre une autre de la même catégorie",
    "swap": "Échanger",
    "seasonalTag": "Limité",
    "previewLabel": "Aperçu du thème",
    "seasonalLocked": "Design saisonnier — disponible uniquement {window}",
    "swapDone": "Mission échangée"
  },
  "shoppingAisle": {
    "produce": "Fruits & légumes",
    "meatFish": "Viande & poisson",
    "dairyEggs": "Produits laitiers & œufs",
    "bakery": "Boulangerie",
    "pantry": "Épicerie (secs)",
    "frozen": "Surgelés",
    "supplements": "Protéines & Compléments",
    "beverages": "Boissons",
    "other": "Autre"
  },
  "eveningTip": {
    "pageTitle": "Ton conseil du soir",
    "pageSubtitle": "Un petit geste maintenant, un grand pas demain",
    "hero": {
      "suggestion": "Le conseil de ce soir",
      "fallback": "Continue de prendre soin de ton alimentation"
    },
    "stats": {
      "today": "Aujourd'hui",
      "kcal": "kcal",
      "dayStreak": "jours d'affilée"
    },
    "howto": "Comment faire, tout simplement",
    "ctaSeeProgress": "Voir tes progrès",
    "ctaLogMeal": "Ajouter un repas",
    "ctaLogWater": "Ajouter de l'eau",
    "ctaFindRecipe": "Trouver une recette protéinée",
    "ctaAddSnack": "Ajouter une collation",
    "ctaSeeSteps": "Voir pas & activité",
    "backHome": "Retour à l'accueil",
    "bullets": {
      "long_streak": "Regarde ta courbe hebdo dans Progrès|Offre-toi une petite récompense – tu l'as méritée|Fixe ton prochain objectif de 7 jours",
      "no_dinner": "Ouvre le journal et note ton dîner|Même un repas léger compte|Seuls les repas notés comptent pour ton bilan et ta série",
      "water_low": "Bois 1 verre maintenant et 1 avant de dormir|Garde une bouteille sur la table de nuit|Commence demain par 1 verre avant le café",
      "protein_gap": "Yaourt grec ou skyr au petit-déj|Œufs durs en collation|Ajoute du thon ou de la dinde au déjeuner",
      "kcal_deficit_large": "Yaourt grec avec miel et fruits secs|Tartine complète à l'avocat|Fruit + une poignée d'amandes",
      "steps_low": "Marche 20 minutes après le dîner|Descends un arrêt plus tôt|Prends les escaliers plutôt que l'ascenseur",
      "great_day": "Continue comme ça demain|Prépare ton petit-déj dès ce soir|Fixe un nouvel objectif hebdo",
      "day_recap": "Jette un œil à ton bilan du jour dans Progrès|Prépare une bouteille d'eau pour demain matin|Planifie ton petit-déj à l'avance"
    }
  },
  "mealType": {
    "colazione": "Petit-déj.",
    "spuntino": "Collation",
    "pranzo": "Déjeuner",
    "merenda": "Goûter",
    "cena": "Dîner",
    "altro": "Autre"
  },
  "common": {
    "networkError": "Serveur inaccessible. Vérifie ta connexion internet et réessaie.",
    "loading": "Chargement…",
    "saving": "Enregistrement…",
    "save": "Enregistrer",
    "saved": "Enregistré ✓",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "close": "Fermer",
    "confirm": "Confirmer",
    "back": "Retour",
    "next": "Suivant",
    "mon": "Lun",
    "tue": "Mar",
    "wed": "Mer",
    "thu": "Jeu",
    "fri": "Ven",
    "sat": "Sam",
    "sun": "Dim",
    "previous": "Précédent",
    "done": "Terminé",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "week": "Semaine",
    "month": "Mois",
    "year": "Année",
    "total": "Total",
    "target": "Objectif",
    "remaining": "Restant",
    "error": "Une erreur est survenue",
    "retry": "Réessayer",
    "protein": "Protéines",
    "carbs": "Glucides",
    "fat": "Lipides",
    "calories": "Calories",
    "colazione": "Petit-déj.",
    "spuntino": "Collation",
    "pranzo": "Déjeuner",
    "merenda": "Goûter",
    "cena": "Dîner",
    "logout": "Se déconnecter",
    "ok": "OK",
    "add": "Ajouter",
    "clear": "Effacer",
    "refresh": "Actualiser",
    "reject": "Refuser",
    "date": "Date",
    "time": "Heure",
    "select": "Sélectionner",
    "gotIt": "Compris",
    "daysAgoShort": "il y a {n} j",
    "copied": "copié",
    "copy": "Copier",
    "dismiss": "Ignorer",
    "errorGeneric": "Une erreur est survenue.",
    "micDenied": "Accès au micro refusé",
    "micUnsupported": "Micro non pris en charge sur cet appareil",
    "more": "Plus",
    "prev": "Retour",
    "recipe": "Recette",
    "remove": "Retirer",
    "stop": "Stop",
    "undo": "Annuler"
  },
  "nav": {
    "home": "Accueil",
    "dashboard": "Tableau de bord",
    "clients": "Clients",
    "appointments": "Rendez-vous",
    "myPlan": "Mon plan",
    "weeklyMenu": "Menu de la semaine",
    "diary": "Journal",
    "progress": "Progrès",
    "profile": "Profil",
    "chat": "Chat",
    "recipes": "Recettes",
    "workouts": "Sport",
    "pantry": "Garde-manger",
    "friends": "Amis",
    "restaurant": "Au restaurant",
    "plate": "Assiette",
    "menu": "Menu",
    "openMenu": "Ouvrir le menu",
    "plan": "Plan alimentaire",
    "training": "Entraînement",
    "settings": "Réglages",
    "logout": "Déconnexion",
    "language": {
      "label": "Langue",
      "it": "Italiano",
      "en": "English",
      "de": "Deutsch",
      "fr": "Français"
    }
  },
  "plate": {
    "title": "Le Principe de l'Assiette Solano Essence",
    "builder": {
      "title": "Compose ton assiette équilibrée",
      "subtitle": "Compose ton repas – simple et sans compter les calories.",
      "chooseVeg": "Choisis d'abord tes légumes.",
      "addProtein": "Très bien ! Ajoute maintenant une source de protéines.",
      "addCarbs": "Ajoute des glucides complexes.",
      "moreVeg": "Presque – encore un peu de légumes !",
      "balanced": "Ton assiette est équilibrée !",
      "fatsExtra": "petit extra",
      "actPhoto": "Photographier l'assiette",
      "actPantry": "Depuis le garde-manger",
      "actSuggest": "Suggérer un plat",
      "actSave": "Enregistrer comme repas",
      "actGenerate": "Générer la recette",
      "genBusy": "Création de ta recette…",
      "genDone": "Recette créée ! Photo en cours…",
      "saved": "Repas enregistré ! Retrouve-le dans le journal.",
      "reset": "Vider l'assiette",
      "ruleTip1": "Les protéines rassasient et protègent tes muscles – p.ex. poulet, poisson, œufs, tofu ou légumineuses.",
      "ruleTip2": "Les légumes apportent volume, vitamines et fibres avec peu de calories.",
      "ruleTip3": "Les boissons sucrées sont des calories cachées – l'eau ou le thé non sucré sont le meilleur choix."
    },
    "check": {
      "btn": "Contrôle photo de l'assiette",
      "busy": "Analyse de ton assiette…",
      "hint": "Photographie ton assiette – l'IA vérifie la répartition 50/25/25.",
      "resultTitle": "Ton contrôle d'assiette",
      "detected": "Détecté",
      "missing": "Il manque encore",
      "fatsSeen": "Bonnes graisses détectées",
      "noFood": "Aucun aliment détecté – photographie ton assiette.",
      "reward": "+15 points Solano pour ton assiette équilibrée !"
    },
    "subtitle": "Des repas équilibrés sans compter chaque calorie",
    "intro": "Bien manger ne doit pas être compliqué. Avec le Principe de l'Assiette Solano Essence, tu composes des repas équilibrés simplement en regardant les proportions dans ton assiette — sans compter les calories.",
    "centerLabel": "Ton assiette",
    "ofYourPlate": "de ton assiette",
    "slice": {
      "veg": "Légumes",
      "protein": "Protéines",
      "carbs": "Glucides complexes"
    },
    "items": {
      "veg": [
        "Salade",
        "Brocolis",
        "Courgettes",
        "Poivrons",
        "Tomates",
        "Chou-fleur",
        "Légumes de saison",
        "Épinards",
        "Carottes",
        "Concombre",
        "Aubergine",
        "Courge",
        "Champignons",
        "Fenouil",
        "Roquette"
      ],
      "protein": [
        "Poulet",
        "Dinde",
        "Poisson",
        "Œufs",
        "Skyr",
        "Fromage blanc maigre",
        "Tofu",
        "Légumineuses",
        "Saumon",
        "Thon",
        "Crevettes",
        "Tempeh",
        "Cottage cheese",
        "Bœuf maigre"
      ],
      "carbs": [
        "Riz",
        "Pâtes complètes",
        "Pommes de terre",
        "Avoine",
        "Quinoa",
        "Pain complet",
        "Patates douces",
        "Boulgour",
        "Millet",
        "Couscous complet"
      ],
      "fats": [
        "Huile d'olive extra vierge",
        "Avocat",
        "Fruits secs",
        "Graines",
        "Amandes",
        "Noix",
        "Graines de lin",
        "Graines de chia"
      ]
    },
    "fats": {
      "title": "Bonnes graisses avec modération",
      "subtitle": "Pas de part dédiée — ajoute-les en petites quantités à chaque repas."
    },
    "rules": {
      "title": "Les 3 règles Solano Essence",
      "r1": "Inclus une source de protéines à chaque repas.",
      "r2": "Remplis la moitié de ton assiette avec des légumes.",
      "r3": "Bois principalement de l'eau et limite les boissons sucrées."
    }
  },
  "plateCheck": {
    "title": "Assiette Solano",
    "tipPrefix": "Astuce :",
    "slice": {
      "veg": "Légumes",
      "protein": "Protéines",
      "carbs": "Glucides",
      "fats": "Bonnes graisses"
    },
    "assigned": "Répartition",
    "extras": "Extras",
    "unknown": "Non reconnu",
    "notDetected": "non reconnu – à vérifier",
    "fatsMissing": "absentes – p. ex. huile d'olive, avocat, noix",
    "fatsHint": "Complément de l'assiette, hors répartition 50/25/25.",
    "satFatTitle": "Beaucoup de graisses saturées aujourd'hui :",
    "satFatHint": "pas de souci de temps en temps – demain, privilégie l'huile d'olive, les noix ou le poisson.",
    "editAssign": "Modifier",
    "verdict": {
      "excellent": "Excellent équilibre 50/25/25",
      "good": "Bien équilibré",
      "adjust": "À rééquilibrer"
    },
    "tip": {
      "more_veg": "ajoute plus de légumes — ils devraient couvrir la moitié de l'assiette.",
      "more_protein": "ajoute une source de protéines (poulet, poisson, œufs, légumineuses).",
      "less_carbs": "réduis un peu les glucides et laisse de la place aux légumes.",
      "less_protein": "trop de protéines — équilibre avec légumes et céréales complètes.",
      "rebalance": "essaie de rapprocher les portions du 50/25/25.",
      "add_fats": "ajoute une bonne graisse : 1 c. à s. d'huile d'olive, ½ avocat ou une poignée de noix.",
      "swap_fats": "remplace une partie des graisses saturées (beurre, crème, charcuterie) par de l'huile d'olive, de l'avocat ou du poisson."
    }
  },
  "plateHistory": {
    "title": "Tendance Assiette",
    "subtitle": "{days} derniers jours",
    "average": "Moy. 7j",
    "empty": "Pas encore de données",
    "dataDays": "{n} jours avec données",
    "targetShort": "cible 50/25/25"
  },
  "plateToday": {
    "target": "Objectif",
    "tomorrow": "Faire mieux demain",
    "keepUp": "Continue — ton assiette était équilibrée aujourd'hui !",
    "shareTitle": "Partager l'assiette Solano",
    "storyKicker": "Mon assiette aujourd'hui",
    "detailsLink": "Ouvrir l'Assiette Solano",
    "summary": {
      "excellent": "ton assiette était presque parfaitement équilibrée aujourd'hui.",
      "good": "ton assiette était bonne aujourd'hui — de petits ajustements aideront.",
      "adjust": "La répartition s'écarte du principe de l'assiette. Vérifie les aliments reconnus et les portions."
    },
    "title": "Assiette du jour",
    "plateOn": "Assiette du",
    "empty": "Pas de déjeuner ni dîner enregistré",
    "emptyHint": "L'Assiette Solano se mesure sur les repas principaux."
  },
  "restaurant": {
    "title": "Au restaurant",
    "subtitle": "Laisse l'IA lire la carte et choisir le meilleur plat pour toi",
    "badgeNew": "NOUVEAU",
    "tabPhoto": "Photo du menu",
    "tabText": "Taper le menu",
    "captureBtn": "Prendre une photo",
    "chooseFileBtn": "Depuis l'appareil",
    "captureHint": "Ouvrir la caméra",
    "chooseFileHint": "Depuis ta galerie",
    "imageSelected": "Image sélectionnée",
    "analyzeBtnNow": "Analyser maintenant",
    "infoTitle": "L'IA analyse pour toi:",
    "infoProtein": "Protéines",
    "infoVeg": "Légumes",
    "infoKcal": "Calories",
    "infoCarbs": "Glucides",
    "infoFat": "Lipides",
    "infoBest": "Meilleur",
    "step1": "Photo ou upload",
    "step2": "L'IA analyse",
    "step3": "Recevoir un conseil",
    "photoHint": "Cadre la carte, puis appuie sur Analyser",
    "textPlaceholder": "Liste les plats (ex. Pâtes tomate, Sole grillée, Tiramisu)…",
    "recentSearches": "Recherches récentes",
    "removeRecent": "Supprimer",
    "analyzeBtn": "Analyser le menu",
    "analyzing": "Analyse en cours…",
    "retakeBtn": "Nouvelle photo",
    "changeMenuBtn": "Changer de menu",
    "mealLabel": "Repas",
    "meals": {
      "colazione": "Petit-déj.",
      "pranzo": "Déjeuner",
      "merenda": "Goûter",
      "cena": "Dîner",
      "spuntino": "Collation"
    },
    "budgetTitle": "Il te reste aujourd'hui",
    "budgetKcal": "kcal",
    "budgetProtein": "Protéines",
    "budgetCarbs": "Gluc.",
    "budgetFat": "Lip.",
    "medScore": "Score Med",
    "noBudget": "Aucun objectif — active-le dans le profil pour des conseils plus fins",
    "resultsTitle": "Mes suggestions",
    "chooseBtn": "Je prends ça",
    "choosingIn": "Ajout au journal…",
    "addedToDiary": "Plat ajouté au journal 🍽️",
    "addError": "Ajout impossible",
    "analyzeError": "Analyse du menu impossible. Réessaye.",
    "needInput": "Fournis une photo du menu ou tape les plats",
    "tipsTitle": "Conseils bonus",
    "verdictGreen": "Excellent choix",
    "verdictYellow": "OK avec précaution",
    "verdictRed": "À éviter",
    "medImpact": {
      "positive": "↑ Med",
      "neutral": "= Med",
      "negative": "↓ Med"
    },
    "backBtn": "Retour au tableau de bord",
    "historyTitle": "Tes favoris au restaurant",
    "reorderBtn": "Recommander",
    "favoriteRemoved": "Retiré des favoris",
    "removeFavorite": "Retirer des favoris"
  },
  "auth": {
    "login": "Se connecter",
    "register": "S'inscrire",
    "email": "E-mail",
    "password": "Mot de passe",
    "forgotPassword": "Mot de passe oublié ?",
    "loginBtn": "Connexion",
    "registerBtn": "Créer un compte",
    "google": "Continuer avec Google",
    "dontHaveAccount": "Pas encore de compte ?",
    "alreadyHaveAccount": "Vous avez déjà un compte ?",
    "welcomeBack": "Bienvenue !",
    "createAccount": "Créez votre compte",
    "accountBlocked": "Ton compte a été suspendu. Contacte le support.",
    "blockedTitle": "Ton compte a été suspendu",
    "blockedBody": "Ce compte a été suspendu pour non-respect de nos règles d'utilisation et ne peut pas se connecter. Si tu penses qu'il s'agit d'une erreur, contacte-nous – nous examinons chaque cas sous 48 heures.",
    "blockedCta": "Contacter le support : info@solano-essence.com",
    "socialLoginOnly": "Ce compte utilise la connexion Google ou Apple. Connecte-toi avec cette méthode ou définis un mot de passe via « Mot de passe oublié ? ».",
    "tooManyAttempts": "Trop de tentatives de connexion échouées. Réessaie dans 15 minutes.",
    "nameRequired": "Merci d'indiquer ton nom.",
    "emailExists": "E-mail déjà enregistré. Connecte-toi.",
    "emailExistsSocial": "E-mail déjà enregistré avec Google ou Apple. Connecte-toi avec cette méthode — ou définis un mot de passe via « Mot de passe oublié ? ».",
    "resetLinkInvalid": "Lien invalide ou déjà utilisé.",
    "resetLinkExpired": "Lien expiré. Demandes-en un nouveau."
  },
  "login": {
    "appleBtn": "Continuer avec Apple",
    "emailLabel": "Adresse e-mail",
    "emailPlaceholder": "nom@exemple.ch",
    "welcomeSub": "Connecte-toi pour poursuivre ton parcours santé.",
    "passwordLabel": "Mot de passe",
    "forgotPassword": "Mot de passe oublié ?",
    "passwordsDontMatch": "Les mots de passe ne correspondent pas",
    "passwordTooShort": "Le mot de passe doit contenir au moins 6 caractères",
    "invalidCredentials": "E-mail ou mot de passe incorrect.",
    "title": "Bon retour.",
    "loginBtn": "Se connecter",
    "hintOr": "ou",
    "googleBtn": "Continuer avec Google",
    "noAccount": "Pas encore de compte ?",
    "registerLink": "S'inscrire",
    "tagline": "Ton essence, ton équilibre.",
    "taglineDesc": "Le portail dédié aux clients Solano Essence. Nutrition, sport et progrès au même endroit.",
    "discipline": "Nutrition clinique · Nutrition sportive",
    "portalTag": "Portail client",
    "registerTitle": "Crée ton compte",
    "registerSubtitle": "Inscris-toi avec e-mail et mot de passe pour commencer.",
    "nameLabel": "Nom complet",
    "confirmPasswordLabel": "Confirmer le mot de passe",
    "registerBtn": "Créer un compte",
    "haveAccount": "Déjà un compte ?",
    "loginLink": "Se connecter"
  },
  "forgot": {
    "tag": "Récupération",
    "title": "Réinitialiser le mot de passe",
    "subtitle": "Entrez votre e-mail : si votre compte existe, vous recevrez un lien pour définir un nouveau mot de passe.",
    "tagline": "On vous aide à revenir, en toute sécurité.",
    "taglineDesc": "Vous recevrez un lien sécurisé par e-mail. Le lien est valable 60 minutes.",
    "submitBtn": "Envoyer le lien",
    "sentTitle": "Vérifiez votre boîte mail",
    "sentBody": "Si l'adresse saisie correspond à un compte Solano Essence, vous recevrez un e-mail avec un lien pour réinitialiser votre mot de passe.",
    "sentHint": "Vous ne trouvez pas l'e-mail ? Consultez vos dossiers spam et promotions.",
    "backToLogin": "Retour à la connexion"
  },
  "reset": {
    "tag": "Nouveau mot de passe",
    "title": "Choisissez votre nouveau mot de passe",
    "subtitle": "Au moins 6 caractères. Vous serez connecté(e) automatiquement après le changement.",
    "tagline": "Un nouveau départ, en toute sécurité.",
    "taglineDesc": "Après avoir confirmé, vous serez redirigé(e) dans votre espace personnel.",
    "newPasswordLabel": "Nouveau mot de passe",
    "confirmPasswordLabel": "Confirmer le nouveau mot de passe",
    "submitBtn": "Confirmer",
    "success": "Mot de passe mis à jour !",
    "invalidTitle": "Lien invalide",
    "invalidBody": "Le lien est manquant ou invalide. Demandez-en un nouveau depuis l'écran Mot de passe oublié."
  },
  "cliDash": {
    "hello": "Bonjour",
    "waterUndo": "Annuler",
    "waterCustom": "Custom",
    "waterCustomPh": "ex. 330",
    "waterSettings": "Réglages eau",
    "waterTargetLabel": "Objectif quotidien (litres)",
    "foodWater": "+ Eau des aliments : ~{ml} ml",
    "waterContainers": "Tes contenants",
    "waterAddContainer": "+ Contenant",
    "waterContainerNamePh": "Nom (ex. gourde)",
    "checkinTitle": "Check-in du jour",
    "checkinOutTitle": "Check-in / Check-out",
    "checkinSection": "Check-in · Matin",
    "checkoutSection": "Check-out · Soir",
    "checkoutMoodQ": "Comment se termine ta journée ?",
    "checkoutSave": "Terminer le check-out",
    "checkoutSaved": "Check-out enregistré ✓",
    "checkinMoodQ": "Comment s'est passée ta journée ?",
    "checkinEnergyQ": "Comment est ton énergie ?",
    "checkinNotePh": "Note facultative …",
    "checkinSave": "Terminer le check-in",
    "checkinSaved": "Check-in enregistré ✓",
    "checkinDone": "Fait",
    "of": "sur",
    "kcalBurnedShort": "Brûlées",
    "today": "Aujourd'hui",
    "calories": "Calories",
    "kcalLeft": "restantes",
    "kcalOver": "en trop",
    "kcalTooLow": "trop peu",
    "kcalBurned": "kcal brûlées",
    "kcalConsumed": "consommées",
    "kcalTarget": "objectif",
    "workoutBonus": "activité",
    "nextMealSuggest": "Prochain : {meal} ~{kcal} kcal",
    "nextMealDone": "Bon travail aujourd'hui !",
    "activities": "Activités",
    "currentWeight": "Poids actuel",
    "logWeightBtn": "Enregistrer",
    "yourPlan": "Ton plan",
    "seeDetail": "Voir le détail",
    "noPlanShort": "Aucun plan actif — voir tous les plans",
    "setKcalTarget": "Définir l'objectif kcal",
    "mealsToday": "Repas d'aujourd'hui",
    "addMeal": "Ajouter un repas",
    "carbs": "Glucides",
    "protein": "Protéines",
    "fat": "Lipides",
    "planCtaTitle": "Objectifs quotidiens et répartition des macros",
    "aiQuotaLeft": "{n} sur {total} actions IA gratuites restantes ce mois-ci",
    "aiQuotaTitle": "Analyses photo gratuites",
    "aiQuotaUsed": "{used} sur {total} utilisées",
    "aiQuotaLeftShort": "Encore {n} ce mois-ci",
    "aiQuotaNoneLeft": "Toutes utilisées — remise à zéro le mois prochain",
    "aiQuotaPro": "Illimitées avec Pro",
    "yesterday": "Hier",
    "weightSaved": "Poids enregistré",
    "kcalInfoTitle": "Comment les kcal sont-elles calculées ?",
    "kcalInfoTotalHint": "activité quotidienne d'aujourd'hui (total Apple Health moins kcal d'entraînement) — hors entraînement.",
    "kcalInfoWorkoutHint": "en plus, depuis tes entraînements enregistrés (WHOOP + manuel, dédupliqué à ±5 min).",
    "kcalInfoFallback": "Sans synchro Apple Health, l'activité quotidienne est estimée depuis tes pas (~0,04 kcal par pas).",
    "steps": "pas",
    "tomorrow": "Demain",
    "weightLogged": "Poids enregistré",
    "kcalRange": "Saisis une valeur entre 500 et 6000",
    "targetSaved": "Objectif mis à jour",
    "hi": "Salut,",
    "goals": "Tes objectifs",
    "hideDetails": "Masquer les détails",
    "showDetails": "Afficher sucres · fibres · sel",
    "microsInfo": "Sucres (max 50 g OMS), Fibres (30 g/jour), Graisses saturées (max 10 % kcal), Sel (max 5 g OMS)",
    "mealEmpty": "Aucun repas ajouté",
    "oneMeal": "1 élément",
    "manyMeals": "éléments",
    "editKcalTitle": "Objectif calorique quotidien",
    "editKcalHint": "Définis combien de calories tu veux consommer par jour.",
    "planCtaHint": "Préréglages (Équilibré, Low Carb, Riche en protéines) et définis tous les objectifs toi-même",
    "saveTarget": "Enregistrer l'objectif",
    "avatarUpdated": "Photo de profil mise à jour",
    "avatarFrameUpdated": "Cadre mis à jour",
    "avatarRemoved": "Photo de profil supprimée",
    "changePhoto": "Changer la photo",
    "avatarFrame": "Cadre",
    "removePhoto": "Supprimer la photo",
    "editAvatar": "Centre ta photo",
    "avatarZoom": "Zoom",
    "sugar": "Sucres",
    "fiber": "Fibres",
    "satFat": "Sat.",
    "salt": "Sel"
  },
  "trend": {
    "last7days": "7 derniers jours"
  },
  "aiCoach": {
    "title": "Coach IA",
    "chipLabel": "Coach",
    "chipSub": "{n} nouveaux conseils",
    "chipReady": "Prêt",
    "subtitle": "Tes conseils pour aujourd'hui",
    "askBtn": "Demander au coach",
    "refresh": "Régénérer",
    "refreshed": "Actualisé !",
    "chatTitle": "Coach IA — Chat",
    "micUnsupported": "Le micro n'est pas pris en charge sur cet appareil",
    "transcribeError": "Je n'ai pas compris, essaie de parler plus clairement",
    "micDenied": "Accès au micro refusé",
    "voiceOff": "Désactiver la voix",
    "voiceOn": "Activer la voix – les réponses sont lues à voix haute",
    "chatHint": "Le coach connaît tes données : macros, scores, assiette, sommeil, poids, séries. Photo ou capture possible.",
    "suggestionsLabel": "Essaie de demander :",
    "thinking": "Le coach réfléchit…",
    "photoReady": "Photo prête à envoyer",
    "attachPhoto": "Joindre une photo",
    "takePhoto": "Prendre une photo",
    "fromGallery": "Photo/capture depuis la galerie",
    "stopRec": "Arrêter l'enregistrement",
    "startRec": "Enregistrer un message vocal",
    "recording": "Enregistrement… touche le micro pour arrêter",
    "transcribing": "Transcription de ta voix…",
    "inputPlaceholder": "Écris une question…",
    "send": "Envoyer",
    "stripHint": "Touche pour voir les {count} conseils du jour"
  },
  "health": {
    "title": "Health Score",
    "chipLabel": "Health",
    "chipEmpty": "Aucun repas",
    "excellent": "Excellent",
    "veryGood": "Très bon",
    "good": "Bon",
    "fair": "À améliorer",
    "poor": "Attention requise",
    "noMeals": "Enregistre tes repas pour obtenir ton score",
    "hint": "Basé sur protéines, fibres, fruits & légumes, graisses saturées, sucres, sel et eau.",
    "muscleTitle": "Muscle",
    "heartTitle": "Cœur",
    "energyTitle": "Énergie",
    "saltPinch": "une pincée de sel",
    "saltHalfTsp": "½ cuillère de sel",
    "saltTsp": "cuillère de sel",
    "saltTspPl": "cuillères de sel",
    "infoAria": "Comment fonctionne le Health Score",
    "infoTag": "Comment ça marche",
    "infoTitle": "Ton Health Score",
    "infoBody": "Le score est calculé sur les repas enregistrés aujourd'hui. Il additionne les points positifs pour les bonnes habitudes et soustrait des pénalités pour les composants à limiter. Maximum 100.",
    "infoPositiveTitle": "Bonus (max 70)",
    "infoProtein": "Protéines (~1,4 g/kg de poids)",
    "infoFiber": "Fibres (30 g/jour)",
    "infoFV": "Fruits & légumes (4 portions)",
    "infoWater": "Eau (2 L)",
    "infoNegativeTitle": "Pénalités (max 30)",
    "infoSatFat": "Graisses saturées (<10% kcal)",
    "infoSugar": "Sucres (<40 g)",
    "infoSalt": "Sel (<5 g)",
    "infoNegativeHint": "Points complets bien sous le seuil, zéro bien au-dessus.",
    "infoTip": "Touche l'anneau HEALTH dans la barre du haut pour voir le détail en direct.",
    "infoSource": "Sources : OMS, EFSA, recommandations nutritionnelles italiennes ISS/CREA 2018.",
    "infoSubTitle": "Les 3 cercles expliqués",
    "infoMuscleDesc": "60 % protéines (part de ton objectif quotidien) + 25 % entraînement (20 min = 100 %) + 15 % adéquation calorique (proche de l'objectif = points complets, trop ou trop peu fait baisser).",
    "infoHeartDesc": "30 % fibres + 30 % fruits & légumes (4 portions = 100 %) + 20 % sel + 20 % graisses saturées. Pour sel & graisses : sous la limite = 100 %, au-dessus la valeur baisse.",
    "infoEnergyDesc": "40 % eau + 30 % glucides + 30 % activité. Activité = le meilleur entre pas (part de ton objectif de pas) OU entraînement (30 min = 100 %) — un workout compte à 100 % même avec peu de pas."
  },
  "streak": {
    "dayOne": "jour",
    "dayMany": "jours",
    "tooltip": "Jours consécutifs ≥ {target} pas · Record : {best}"
  },
  "med": {
    "title": "Score méditerranéen",
    "chipLabel": "Méd",
    "chipDays": "Derniers {days}j",
    "chipEmpty": "Enregistre",
    "subtitle": "Derniers {days} jours",
    "hint": "Adhésion au régime méditerranéen : plus d'huile d'olive, poisson, légumes, légumineuses, céréales complètes et fruits secs ; moins de viande rouge.",
    "noData": "Enregistre les repas des 7 derniers jours",
    "infoAria": "Comment fonctionne le score",
    "infoTag": "Comment ça marche",
    "infoTitle": "Ton score méditerranéen",
    "infoBody": "Nous analysons les 7 derniers jours de ton journal alimentaire et détectons 8 groupes clés du régime méditerranéen (plus une pénalité pour la viande rouge). Chaque repas est classé selon ses ingrédients ; si tu indiques aussi les grammes (ex. \"80g épinards\"), nous calculons les portions réelles selon les recommandations CREA/EFSA.",
    "infoTargetsTitle": "Objectifs hebdomadaires · portion",
    "infoTip": "Astuce : indique les grammes dans tes repas (ex. \"150g haricots\") pour un décompte plus précis. Sans grammes, chaque repas compte pour 1 portion.",
    "infoSource": "Source : MedDiet Adherence Score (Trichopoulou 2003, PREDIMED), recommandations CREA/EFSA sur les portions.",
    "penaltyHint": "Chaque portion au-delà de 1/semaine retire des points (max −6).",
    "tipTitle": "Conseil du jour",
    "tipCta": "Voir les recettes adaptées",
    "genEmpty": "Aucune recette adaptée dans ta bibliothèque",
    "genBtn": "Générer une nouvelle recette avec l'IA",
    "tips": {
      "olive_oil": "Ajoute aujourd'hui une cuillère d'huile d'olive – p.ex. sur les légumes ou en salade.",
      "fish": "Prévois une portion de poisson aujourd'hui ou demain – p.ex. saumon, truite ou thon.",
      "vegetables": "Encore une portion de légumes aujourd'hui – p.ex. salade, brocoli ou légumes rôtis.",
      "fruits": "Prends encore un fruit aujourd'hui – p.ex. pomme, baies ou banane.",
      "legumes": "Encore une portion de légumineuses aujourd'hui – p.ex. lentilles, pois chiches ou haricots.",
      "whole_grains": "Choisis le complet aujourd'hui – p.ex. flocons d'avoine, pain ou riz complet.",
      "nuts_seeds": "Une petite poignée de noix ou graines en snack – p.ex. amandes ou noix.",
      "dairy_fermented": "Encore un yaourt, skyr ou kéfir aujourd'hui – idéal en snack ou au petit-déjeuner.",
      "red_meat": "Beaucoup de viande rouge cette semaine – remplace aujourd'hui par du poisson, de la volaille ou des légumineuses.",
      "processed_meat": "Réduis la charcuterie – essaie aujourd'hui le houmous, le fromage ou l'avocat."
    }
  },
  "moderation": {
    "newReportToast": "Nouveau signalement ({reason}) concernant {name}",
    "openReports": "{n} signalements ouverts",
    "report": "Signaler",
    "block": "Bloquer",
    "unblock": "Débloquer",
    "reportTitle": "Signaler {name}",
    "reason_harassment": "Harcèlement",
    "reason_spam": "Spam",
    "reason_inappropriate": "Contenu inapproprié",
    "reason_other": "Autre",
    "reportTextPh": "Facultatif : que s'est-il passé ?",
    "reportHint": "Ton signalement est transmis de manière confidentielle à l'équipe Solano et examiné sous 24 h.",
    "reportSubmit": "Envoyer le signalement",
    "reportSent": "Merci – ton signalement a été transmis.",
    "blockConfirm": "Bloquer {name} ? Vous ne vous verrez plus ; messages et demandes d'amitié (aussi par code) ne seront plus possibles.",
    "blockedOk": "{name} a été bloqué(e).",
    "unblockedOk": "Blocage levé.",
    "sendBlocked": "Message impossible – ce contact est bloqué.",
    "blockedTitle": "Utilisateurs bloqués",
    "blockedHint": "Les personnes bloquées ne peuvent pas t'envoyer de messages ni de demandes.",
    "blockedEmpty": "Tu n'as bloqué personne.",
    "filter_open": "Ouverts",
    "filter_resolved": "Traités",
    "filter_all": "Tous",
    "noReports": "Aucun signalement.",
    "reportedUser": "Signalé",
    "reporter": "Signalé par",
    "userBlocked": "bloqué",
    "messageDeleted": "message supprimé",
    "deleteMessage": "Supprimer le message",
    "blockUser": "Bloquer l'utilisateur",
    "blockConfirmAdmin": "Bloquer cet utilisateur ? Toutes les sessions seront fermées.",
    "resolve": "Traité",
    "deletedOk": "Message supprimé.",
    "userBlockedOk": "Utilisateur bloqué.",
    "resolvedOk": "Signalement traité."
  },
  "friends": {
    "remove": "Retirer l'ami",
    "photoCamera": "Prendre une photo",
    "photoFile": "Envoyer une image (galerie/fichier)",
    "shareTitle": "Partager",
    "shareTabMeals": "Repas",
    "shareTabRecipes": "Recettes",
    "shareRecipeHint": "Choisis une recette enregistrée – elle sera envoyée dans le chat sous forme de carte avec les valeurs nutritionnelles.",
    "shareRecipeEmpty": "Aucune recette trouvée.",
    "searchRecipes": "Rechercher une recette…",
    "recipeShared": "Recette",
    "openRecipe": "Ouvrir la recette",
    "perServing": "par portion",
    "shareMeal": "Partager un repas",
    "shareMealTitle": "Partager un repas",
    "shareMealHint": "Choisis un repas enregistré – il sera envoyé dans le chat avec photo et valeurs nutritionnelles.",
    "shareMealEmpty": "Aucun repas enregistré pour l'instant.",
    "mealShared": "Repas",
    "removeConfirm": "Retirer cet ami ? La conversation reste masquée jusqu'à une nouvelle connexion.",
    "openChat": "Ouvrir",
    "toastGoToChat": "Touchez pour ouvrir le chat",
    "chatEmpty": "…",
    "pageTitle": "Amis",
    "pageSubtitle": "Trouve des amis et motivez-vous",
    "requestsInbox": "Demandes reçues",
    "addSection": "Ajouter des amis",
    "yourFriends": "Tes amis",
    "leaderboardTitle": "Classement hebdomadaire",
    "leaderboardHint": "Health Score moyen sur les 7 derniers jours",
    "computingBoard": "Calcul du classement…",
    "boardEmpty": "Aucun ami dans le classement pour l'instant.",
    "boardEmptyHint": "Ajoute des amis pour vous comparer chaque semaine.",
    "daysActive": "{n} jours actifs",
    "noDayTracked": "Aucun jour suivi",
    "you": "Toi",
    "yourCode": "Ton code",
    "copy": "Copier",
    "regenerate": "Régénérer",
    "shareHint": "Partage ce code avec un ami par WhatsApp. Il le saisit dans son app et vous devenez amis.",
    "shareWa": "Partager sur WhatsApp",
    "hasCodeQ": "Tu as le code d'un ami ?",
    "redeemBtn": "Ajouter",
    "codeInvalid": "Le code doit contenir 6 caractères",
    "alreadyFriends": "Vous êtes déjà amis",
    "codeNotValid": "Code invalide",
    "copyOk": "Code copié",
    "copyErr": "Impossible de copier",
    "newCodeGen": "Nouveau code généré",
    "genericError": "Erreur",
    "waMessage": "Salut ! Ajoute-moi sur Solano Essence avec mon code : {code}\nTélécharge l'app : https://solano-essence.com",
    "chatMsgPlaceholder": "Écris un message…",
    "removeFriend": "Retirer l'ami",
    "confirmRemove": "Es-tu sûr(e) de vouloir retirer cet ami ?",
    "removedOk": "Ami retiré",
    "accept": "Accepter",
    "decline": "Refuser",
    "noChange": "Aucun changement",
    "pushBannerTitle": "Activer les notifications",
    "pushBannerHint": "Reçois une alerte même quand l'app est fermée lorsqu'un ami t'écrit",
    "pushBannerCta": "Activer",
    "pushToastOk": "Notifications activées !",
    "emptyList": "Aucun ami pour l'instant. Cherche quelqu'un ci-dessus.",
    "confirmRegen": "En régénérant le code, l'ancien ne fonctionnera plus. Continuer ?"
  },
  "learn": {
    "title": "Apprendre",
    "chipLabel": "Apprendre",
    "chipNew": "Nouveauté",
    "subtitle": "Ta pilule du jour",
    "next": "Pilule suivante",
    "loading": "Je choisis une pilule pour toi…",
    "empty": "Aucune pilule disponible",
    "catNutrition": "Nutrition",
    "catBasics": "Bases",
    "basicsProgress": "Parcours de base · Leçon {n} sur {total}",
    "quizTitle": "Mini-quiz",
    "quizCorrect": "Exact !",
    "quizCorrectSp": "Exact ! +{points} Solano Points",
    "quizWrong": "Pas tout à fait — la bonne réponse est surlignée.",
    "catHealth": "Santé",
    "catRecipes": "Recettes",
    "catMyths": "Mythes démystifiés",
    "pickCategory": "Changer de sujet",
    "limitReached": "Tu as vu toutes les pilules du jour — reviens demain !",
    "statsTitle": "Ta semaine d'apprentissage",
    "weekCorrect": "{correct}/{answered} justes",
    "streak": "Série de {n} jours",
    "streakNone": "Commence ta série d'apprentissage aujourd'hui",
    "streakNext": "Bonus dès {n} jours",
    "streakBonusToday": "+{points} bonus aujourd'hui",
    "streakBonus": "Série de {n} jours : +{points} Solano Points bonus !",
    "reviewTitle": "Révision",
    "reviewDue": "{n} à revoir",
    "reviewStart": "Test de mémoire : revoir une ancienne carte",
    "reviewHint": "Carte d'il y a {days} jours — tu t'en souviens ?",
    "reviewNone": "Aucune révision en attente — continue !",
    "reviewCorrect": "C'est acquis ! +{points} Solano Points",
    "reviewWrong": "Pas tout à fait — retiens la réponse surlignée.",
    "reviewNext": "Révision suivante ({n})"
  },
  "challenges": {
    "title": "Défis du jour",
    "chipLabel": "Défis",
    "subtitle": "{done}/{total} atteints aujourd'hui",
    "allDone": "Tous les défis atteints aujourd'hui ! 🎉",
    "hint": "Se réinitialise chaque jour. Reste motivé !",
    "completed": "Atteint",
    "remaining": "restent",
    "edit": "Personnaliser",
    "editTitle": "Personnalise tes défis",
    "editDesc": "Définis les objectifs quotidiens et désactive ceux qui ne t'intéressent pas.",
    "steps": "Pas",
    "fiber": "Fibres",
    "protein": "Protéines",
    "water": "Eau",
    "saveBtn": "Enregistrer",
    "saved": "Défis mis à jour !",
    "resetDefaults": "Valeurs par défaut",
    "atLeastOne": "Au moins un défi doit rester actif"
  },
  "wearable": {
    "appleBridgeHint": "Synchronise les données prises en charge de l'Apple Watch ainsi que des apps et appareils connectés comme Garmin, Fitbit, Polar et les balances connectées.",
    "directSoonTitle": "Connexions directes – bientôt disponibles",
    "directSoonHint": "Les données de base de ces fournisseurs peuvent déjà être synchronisées via Apple Health. Les connexions directes ajouteront plus tard des mesures spécifiques au fabricant.",
    "healthkitDone": "Synchro HealthKit terminée : {days} jours",
    "healthkitDenied": "Accès HealthKit impossible. Vérifie les autorisations dans Réglages → Santé → Accès aux données.",
    "healthkitServerError": "Erreur serveur lors de l’enregistrement des données Santé. Réessaie plus tard.",
    "healthkitNetworkError": "Pas de connexion au serveur. Vérifie ta connexion Internet.",
    "healthkitHint": "Cette app peut lire les données Santé directement depuis ton iPhone — aucune app supplémentaire nécessaire.",
    "healthConnectSoon": "L'intégration Health Connect pour Android arrive bientôt. D'ici là, tu peux connecter WHOOP, Garmin & co. directement.",
    "healthConnectBridgeHint": "Lit les pas, calories, sommeil, fréquence cardiaque au repos, VFC, poids et entraînements depuis Health Connect – donc de Samsung Health, Fitbit, Garmin, Google Fit & co.",
    "healthConnectDone": "Synchro Health Connect terminée : {days} jours",
    "healthConnectCta": "Synchroniser directement depuis Health Connect",
    "healthConnectSyncing": "Lecture de Health Connect…",
    "healthConnectDenied": "Accès à Health Connect impossible. Ouvre l'app Health Connect → Autorisations des apps → Solano Essence et autorise la lecture.",
    "healthConnectMissing": "Health Connect n'est pas installé ou est obsolète sur cet appareil. Installe/mets-le à jour depuis le Play Store.",
    "healthConnectEmpty": "Autorisation OK, mais Health Connect ne contient aucune donnée des 7 derniers jours. Active la synchronisation avec Health Connect dans ton app fitness (Samsung Health → Paramètres → Health Connect, Fitbit, Garmin Connect, Google Fit …) puis réessaie.",
    "healthConnectNoPermission": "Aucune autorisation Health Connect accordée. Ouvre Health Connect → Autorisations des apps → Solano Essence et autorise la lecture des pas, calories, sommeil, fréquence cardiaque et poids.",
    "healthConnectOpen": "Ouvrir Health Connect",
    "healthConnectSoonShort": "Bientôt via Health Connect",
    "healthkitSyncing": "Lecture de HealthKit…",
    "healthkitCta": "Synchroniser directement depuis HealthKit",
    "appleWaiting": "En attente de l'iPhone",
    "connected": "Connecté",
    "paused": "En pause",
    "notConnected": "Non connecté",
    "manualOnly": "Import manuel uniquement",
    "comingSoon": "Bientôt disponible",
    "lastSync": "Dernière synchro",
    "appleAutoHint": "Se synchronise automatiquement depuis ton iPhone en arrière-plan. Pour actualiser tout de suite : ouvre « Health Auto Export » → Run Now.",
    "connectCta": "Connecter",
    "needsCreds": "Identifiants serveur manquants — bientôt disponible",
    "applePlaceholder": "Connecte Apple Health via l'app iOS « Health Auto Export » : génère un token ci-dessous, colle-le dans l'app — pas, poids et calories arrivent automatiquement.",
    "pause": "Pause",
    "resume": "Reprendre",
    "syncing": "Synchro…",
    "syncNow": "Synchroniser",
    "disconnect": "Déconnecter",
    "whoopConnectedOk": "WHOOP connecté — première synchro en cours…",
    "disconnectedOk": "Déconnecté",
    "syncedOk": "Synchro terminée : {days} jours",
    "resumedOk": "Synchro reprise",
    "pausedOk": "Synchro en pause",
    "myDevices": "Mes appareils",
    "addDevice": "Ajouter un appareil",
    "noDevices": "Aucun appareil connecté pour l'instant.",
    "active": "Actif",
    "available": "Disponible",
    "iosOnly": "Dans l'app Solano (iPhone/Android)",
    "whoopNoSteps": "WHOOP ne synchronise pas les pas via l'API. Connecte Apple Health ci-dessous pour des pas, poids et calories précis automatiquement.",
    "manualEmpty": "Saisis au moins une valeur",
    "manualSavedOk": "Valeurs enregistrées",
    "manualTag": "Sans wearable",
    "manualTitle": "Saisir les valeurs manuellement",
    "manualDate": "Date",
    "manualSleepMin": "Sommeil (min)",
    "manualRestingHr": "FC au repos (bpm)",
    "manualHrv": "VFC (ms)",
    "manualSteps": "Pas",
    "manualActiveKcal": "Kcal actives",
    "manualRecovery": "Récupération (0-100)",
    "manualSaveCta": "Enregistrer les valeurs",
    "manualRecent": "Entrées récentes",
    "appleTokenCreated": "Nouveau token généré",
    "appleRevokeConfirm": "Supprimer ce token ? L'app iPhone n'enverra plus de données.",
    "appleTokenRevoked": "Token supprimé",
    "appleTestOk": "Test reçu ✓",
    "appleTestFail": "Test échoué",
    "appleResetConfirm": "Effacer les valeurs Apple d'aujourd'hui ? Si Health Auto Export renvoie des données, elles écraseront.",
    "appleResetOk": "Valeurs du jour effacées",
    "appleSetupClose": "Fermer la configuration",
    "appleSetupOpen": "Configuration / Import automatique",
    "appleStep1": "Installe l'app « Health Auto Export » sur ton iPhone (gratuit)",
    "appleStep2": "Ouvre l'app → « Automations » → « + Add Automation » → « REST API »",
    "appleStep3": "Colle l'URL ci-dessous → sélectionne : Steps, Weight, Active Energy, Resting HR, Sleep, HRV, Workouts",
    "appleStep4": "Enregistre et touche « Run Now » — les données arrivent en ~20 secondes",
    "appleGenerateToken": "Générer un token",
    "appleWebhookUrl": "URL du webhook (à coller dans Health Auto Export)",
    "appleTokenCreatedAt": "Créé",
    "appleLastPayload": "Dernier import",
    "appleHeaderAlt": "Alternative : en-tête au lieu du token dans l'URL",
    "appleHeaderAltHint": "Utilise SOIT l'URL avec ?token ci-dessus, SOIT ces trois champs (URL + Key + Value) sous « Add headers » — pas les deux.",
    "appleTestWebhook": "Tester le webhook",
    "appleResetToday": "Réinitialiser aujourd'hui",
    "appleRotateToken": "Régénérer",
    "appleRevokeToken": "Supprimer"
  },
  "shop": {
    "unknown": {
      "title": "Produit inconnu – aide Solano à l’apprendre",
      "subtitle": "Photographie le tableau nutritionnel. L’IA lit les valeurs, tu confirmes – et au prochain scan Solano reconnaît le produit immédiatement.",
      "photoLabel": "Photographier le tableau nutritionnel",
      "analyzing": "L’IA lit le tableau …",
      "manual": "Saisir manuellement",
      "analyzeFailed": "Tableau illisible – reprends la photo ou saisis manuellement.",
      "aiRead": "Lu par l’IA – vérifie rapidement",
      "name": "Nom du produit",
      "brand": "Marque",
      "serving": "Portion (p. ex. 30 g)",
      "ingredients": "Ingrédients (facultatif, pour le bonus méditerranéen)",
      "save": "Enregistrer et évaluer",
      "saved": "Produit enregistré – merci !",
      "nameRequired": "Indique un nom de produit.",
      "shared": "Les produits appris sont disponibles pour tous les utilisateurs Solano.",
      "f": {
        "kcal": "kcal",
        "protein": "Protéines g",
        "carbs": "Glucides g",
        "sugar": "Sucres g",
        "fat": "Lipides g",
        "satfat": "AG sat. g",
        "fiber": "Fibres g",
        "salt": "Sel g"
      }
    },
    "logToDiary": "Dans le journal",
    "perServing": "Valeurs par portion ({s})",
    "show100": "voir pour 100 g",
    "showServing": "voir par portion",
    "clearConfirm": "Vraiment vider l’historique ?",
    "yes": "Oui",
    "no": "Non",
    "disclaimer": "Le score Solano est une orientation et ne remplace pas un conseil nutritionnel ou médical.",
    "info": {
      "scores": "Nutri-Score : évaluation officielle du produit (A–E). Score Solano : notre note de 0 à 100, adaptée à ton objectif.",
      "thresholds": "Niveaux : dès 70 « À acheter » · 40–69 « Ok avec modération » · sous 40 « Plutôt non ».",
      "how": "Comment le score est calculé : base issue du Nutri-Score, puis plus/moins pour le sucre, les graisses saturées, le sel, les fibres, les protéines, le degré de transformation, les additifs et les ingrédients méditerranéens – pondérés selon ton objectif."
    },
    "med": {
      "med_good_ingredients": "Compatible avec l’alimentation méditerranéenne : bons ingrédients",
      "med_good_natural": "Compatible avec l’alimentation méditerranéenne : peu transformé",
      "med_neutral": "Méditerranéen neutre – ok avec modération",
      "med_poor_processed": "Peu méditerranéen : ultra-transformé",
      "med_poor_sugar": "Peu méditerranéen : beaucoup de sucre ou d’édulcorants"
    },
    "altTip": {
      "food": "Conseil du coach : mise sur des bases non transformées – yaourt nature, skyr, noix, fruits ou céréales complètes battent tout produit tout prêt.",
      "beverage": "Conseil du coach : eau, thé ou café non sucré – avec du citron ou de la menthe si tu veux du goût."
    },
    "addToList": "Ajouter à la liste de courses",
    "onList": "Sur la liste",
    "addedToList": "Ajouté à ta liste de courses",
    "alreadyOnList": "Déjà sur ta liste de courses",
    "listTicked": "Coché et ajouté au garde-manger : {name}",
    "listTickedTitle": "Coché sur ta liste – maintenant dans le garde-manger",
    "verifiedSeal": "Vérifié par Solano",
    "verifiedHint": "Les valeurs nutritionnelles de ce produit ont été contrôlées par l'équipe Solano.",
    "miniList": {
      "title": "Ta liste de courses",
      "open": "{n} à acheter",
      "more": "+{n} autres"
    },
    "openList": "Ouvrir la liste",
    "per100g": "Valeurs pour 100 g",
    "per100ml": "Boisson – valeurs pour 100 ml",
    "stats": {
      "title": "Ton bilan courses",
      "smartRate": "Fréquence de « À acheter » plutôt que « Plutôt non » ces {days} derniers jours",
      "summary": "{total} scans · score moyen {avg}"
    },
    "altTitle": "Meilleure alternative",
    "altLoading": "Recherche d’une alternative plus saine …",
    "altTap": "Touche pour les détails",
    "title": "Check courses",
    "subtitle": "Scanne un produit en magasin – Solano te dit s’il mérite une place dans ton panier.",
    "hint": "Place le code-barres (EAN) dans le cadre",
    "enterManually": "Saisir le code manuellement",
    "checking": "Analyse du produit …",
    "notFound": "Produit introuvable – essaie un autre code.",
    "error": "Échec de l’analyse. Réessaie.",
    "solanoScore": "Score Solano",
    "verdict": {
      "buy": "À acheter",
      "moderate": "Ok avec modération",
      "avoid": "Plutôt non"
    },
    "goal": {
      "lose": "Pondéré pour ton objectif : perte de poids",
      "gain": "Pondéré pour ton objectif : prise de muscle",
      "maintain": "Évaluation équilibrée"
    },
    "reason": {
      "sugar_high": "Très sucré : {v} g/100 g",
      "sugar_mid": "Sucré : {v} g/100 g",
      "sugar_low": "Peu de sucre : {v} g/100 g",
      "satfat_high": "Riche en graisses saturées : {v} g/100 g",
      "satfat_mid": "Un peu de graisses saturées : {v} g/100 g",
      "salt_high": "Très salé : {v} g/100 g",
      "salt_mid": "Un peu de sel : {v} g/100 g",
      "fiber_high": "Riche en fibres : {v} g/100 g",
      "fiber_mid": "Bonnes fibres : {v} g/100 g",
      "protein_high": "Riche en protéines : {v} g/100 g",
      "protein_mid": "Bonne source de protéines : {v} g/100 g",
      "kcal_high": "Dense en calories : {v} kcal/100 g",
      "nova_4": "Ultra-transformé (NOVA 4)",
      "nova_3": "Transformé (NOVA 3)",
      "nova_1": "Non transformé (NOVA 1)",
      "additives": "{v} additifs",
      "med_olive": "Méditerranéen : huile d’olive / olives",
      "med_nuts": "Méditerranéen : noix / amandes",
      "med_wholegrain": "Méditerranéen : céréales complètes",
      "med_legumes": "Méditerranéen : légumineuses",
      "med_fish": "Méditerranéen : poisson",
      "palm_oil": "Contient de l’huile de palme",
      "few_ingredients": "Liste d’ingrédients courte – peu transformé",
      "bev_water": "Eau – le meilleur choix",
      "bev_unsweetened": "Non sucré, quasi sans calories",
      "bev_sugar_high": "Boisson sucrée : {v} g de sucre/100 ml",
      "bev_sugar_mid": "Très sucré : {v} g/100 ml",
      "bev_sugar_some": "Un peu de sucre : {v} g/100 ml",
      "bev_sugar_low": "Peu de sucre : {v} g/100 ml",
      "bev_kcal_high": "Calories liquides : {v} kcal/100 ml",
      "sweeteners": "Contient des édulcorants",
      "fruit_juice": "Pur jus de fruits (sucre naturel)",
      "alcohol": "Boisson alcoolisée"
    },
    "coach": "Coach",
    "coachThinking": "Ton coach regarde ça …",
    "coachUnavailable": "Commentaire du coach indisponible pour le moment.",
    "n": {
      "kcal": "kcal",
      "protein": "Protéines",
      "sugar": "Sucres",
      "salt": "Sel"
    },
    "next": "Scanner le suivant",
    "logAnyway": "Enregistrer quand même",
    "history": "Scannés récemment",
    "clear": "Vider",
    "emptyHistory": "Tes produits scannés apparaîtront ici pour comparer.",
    "cameraStarting": "Démarrage de la caméra …",
    "retry": "Réessayer",
    "fromPhoto": "Depuis une photo",
    "err": {
      "permission": "Accès caméra refusé. Autorise-le dans les Réglages ou utilise une photo.",
      "nodevice": "Aucune caméra trouvée.",
      "generic": "Impossible de démarrer la caméra.",
      "notfound": "Aucun code-barres détecté sur la photo."
    }
  },
  "quickTrack": {
    "qrScan": "Scanner QR recette",
    "voice": "Voix",
    "photo": "Photo IA",
    "barcode": "Scanner EAN",
    "shop": "Check courses",
    "fridge": "Depuis le frigo",
    "search": "Chercher un aliment",
    "manual": "Saisie manuelle",
    "addMeal": "Ajouter un repas",
    "title": "Suivi rapide"
  },
  "pantry": {
    "foodScore": {
      "info": {
        "title": "Comment le Food Score est calculé",
        "intro": "Le score (0–100) évalue à quel point ton garde-manger actuel est sain et équilibré. Il se compose de trois parties pondérées :",
        "catBody": "Combien de catégories saines tu couvres (légumes, fruits, poisson, légumineuses, céréales complètes, produits laitiers …) et la qualité des produits. Objectif : au moins 8 catégories saines différentes.",
        "medBody": "À quel point ton garde-manger correspond au régime méditerranéen : légumes, poisson, légumineuses et huile d'olive comptent positivement — sucreries et produits ultra-transformés pénalisent.",
        "freshBody": "Basé sur les dates de péremption : les produits périmés comptent 0, ceux qui expirent sous 3 jours peu, les plus durables au maximum. Sans dates, cette partie compte comme neutre (50).",
        "sparsity": "Remarque : avec moins de 5 produits, le score est réduit proportionnellement pour qu'un garde-manger presque vide ne paraisse pas \"équilibré\"."
      },
      "verdict": {
        "empty": "Ajoute des produits pour calculer ton score."
      },
      "title": "Food Score",
      "sub": {
        "categories": "Variété",
        "mediterranean": "Méditerranéen",
        "freshness": "Fraîcheur"
      },
      "freshnessHint": "Astuce : ajoute les dates de péremption à tes produits pour rendre le score de fraîcheur pertinent — sans dates, il compte comme neutre (50)."
    },
    "needName": "Nom requis",
    "itemAdded": "Ajouté au garde-manger",
    "scanEan": "Scanner EAN",
    "scanEanHint": "Un produit à la fois",
    "namePlaceholder": "ex. Œufs, tomates, yaourt grec…",
    "qtyPlaceholder": "Qté",
    "expiryLabel": "Péremption",
    "notifTitle": "Alerte péremption",
    "notifBodyOne": "{name} expire demain. Utilise-le aujourd'hui.",
    "notifBodyMany": "{count} produits vont bientôt expirer (ex. {name}).",
    "shoppingEmptyHappy": "🎉 Tout est acheté !",
    "swap": {
      "dismissed": "Suggestion masquée",
      "restored": "Suggestion restaurée",
      "added": "{name} ajouté à la liste",
      "title": "Alternatives plus saines",
      "subtitle": "{n} produits avec un Nutri-Score bas",
      "allDismissed": "Toutes les suggestions sont masquées",
      "dismiss": "Ça me va",
      "hideHidden": "Masquer",
      "showHidden": "Afficher les masquées ({n})",
      "restore": "Restaurer"
    },
    "bulkDeleted": "{n} produits supprimés",
    "mergedToast": "{name} : {qty}",
    "added": "Ajouté au garde-manger",
    "scanError": "Ticket illisible",
    "receiptAdded": "{count} produits ajoutés au garde-manger",
    "needMore": "Ajoute au moins 2 ingrédients",
    "recipeCreated": "Recette créée !",
    "title": "Garde-manger",
    "subtitle": "Ce que tu as à la maison",
    "scanReceipt": "Scanner un ticket",
    "whatToCook": "Quoi cuisiner ?",
    "selectMultiple": "Sélectionner",
    "stats": {
      "products": "Produits",
      "categories": "Catégories",
      "expiring": "Bientôt périmés",
      "shopping": "Liste de courses"
    },
    "searchExtendedPlaceholder": "Chercher nom, catégorie ou notes…",
    "searchPlaceholder": "Chercher dans ton garde-manger…",
    "filter": {
      "all": "Tous",
      "fresh": "Frais",
      "soon": "Bientôt périmés",
      "expired": "Périmés",
      "favorites": "Favoris",
      "healthy": "A/B uniquement"
    },
    "empty": "Ton garde-manger est vide. Ajoute des produits ou scanne un ticket.",
    "useSoonTitle": "À utiliser en premier",
    "rest": "Reste du garde-manger",
    "allItems": "Tous les produits",
    "noResults": "Aucun résultat pour les filtres actuels",
    "receiptTitle": "Vérifier les articles du ticket",
    "receiptDesc": "Décoche ce que tu ne veux pas enregistrer et corrige noms/quantités si besoin.",
    "scanning": "Lecture du ticket…",
    "autoSuggested": "AUTO",
    "receiptEmpty": "Aucun article reconnu",
    "addAll": "Tout ajouter",
    "selectAll": "Tous",
    "nSelected": "{n} sélectionnés",
    "addToShopping": "Ajouter à la liste",
    "expired": "Périmé il y a {days} j",
    "today": "Expire aujourd'hui",
    "inDays": "Dans {days} j",
    "expiryChip": {
      "fresh": "Frais"
    },
    "noExpiry": "Pas de date de péremption",
    "categoryLabel": "Catégorie",
    "storageLabel": "Où le ranger",
    "notes": "Notes",
    "notesPlaceholder": "ex. bio, ouvert…",
    "deducted": {
      "restored": "{name} restauré"
    }
  },
  "progress": {
    "title": "Progrès",
    "monthlyTitle": "Progrès",
    "subtitle": "Suivi complet",
    "latest": "Dernier",
    "bmiTitle": "Indice de masse corporelle",
    "bmiUnder": "Insuffisance",
    "bmiNormal": "Poids idéal",
    "bmiOver": "Surpoids",
    "bmiObese": "Obésité",
    "thisWeek": "7 derniers jours",
    "noDataConnect": "Aucune donnée · Connecte ton wearable",
    "weightLabel": "Poids",
    "waistLabel": "Tour de taille",
    "recapNow": "actuel",
    "recapUnchanged": "inchangé sur 30 jours",
    "recapNeedTwo": "2 mesures nécessaires pour l’évolution",
    "recapNoWaist": "Pas encore de tour de taille – saisis-le sous « Corps »",
    "recapNoWeight": "Aucun poids saisi",
    "workoutsLabel": "Entraînements",
    "diaryLabel": "Journal",
    "waterLabel": "Eau",
    "hitTarget": "moyenne quotidienne",
    "streakLabel": "jours consécutifs",
    "streakToast7Title": "7 jours d'hydratation ! 💧",
    "streakToast7Desc": "Une semaine entière à l'objectif. Ton corps te remercie !",
    "streakToast14Title": "Deux semaines d'affilée ! 🔥",
    "streakToast14Desc": "L'hydratation est devenue une habitude. Continue !",
    "streakToast30Title": "30 jours consécutifs ! 🏆",
    "streakToast30Desc": "Un mois entier à l'objectif. Tu es en feu !",
    "measure": "mesure",
    "measures": "mesures",
    "days": "jours",
    "needAtLeastOne": "Saisis au moins une mesure",
    "measurementsLogged": "Mesures enregistrées",
    "navOverview": "Aperçu",
    "navNutrition": "Nutrition",
    "navBody": "Corps",
    "weightTrend": "Évolution du poids",
    "goalShort": "Objectif",
    "prevPeriod": "Période précédente",
    "kcalTrend": "Évolution des calories · 30 jours",
    "kcalAvg": "moy. par jour",
    "kcalVsGoal": "kcal vs objectif",
    "kcalBand": "Zone cible",
    "macroTrend": "Évolution des macros · 30 jours",
    "macroProtein": "Protéines",
    "macroCarbs": "Glucides",
    "macroCarbsShort": "Glucides",
    "macroTipCta": "Voir les recettes adaptées",
    "macroRecipesHigh": "Recettes riches en {macro}",
    "macroRecipesLow": "Recettes pauvres en {macro}",
    "macroRecipesHint": "Triées par part des calories par portion – touche pour ouvrir la recette.",
    "macroRecipesEmpty": "Pas encore de recettes adaptées dans ta collection.",
    "macroFat": "Lipides",
    "macroOfGoal": "{pct} % de {goal} g",
    "kcalInBand": "{n} jours sur {total} enregistrés dans la zone cible (±10 %)",
    "rangeW": "Semaine",
    "rangeM": "Mois",
    "range3M": "3 mois",
    "rangeY": "Année",
    "rangeAll": "Tout",
    "needMore": "Enregistre au moins 2 poids pour voir le graphique.",
    "navPhotos": "Photos",
    "logMeasurements": "Saisir les mesures",
    "armGroup": "Bras",
    "leftShort": "Gauche",
    "rightShort": "Droit",
    "thighGroup": "Cuisse",
    "calfGroup": "Mollet",
    "saveMeasurements": "Enregistrer les mesures",
    "measChartTitle": "Évolution des mesures",
    "history": "Historique des mesures",
    "trend": "Évolution des mesures",
    "needMoreData": "Il faut au moins 2 entrées pour afficher la tendance.",
    "navHealth": "Appareils et apps"
  },
  "weightGoal": {
    "title": "Poids cible",
    "setPrompt": "Définis ton poids cible →",
    "currentToTarget": "Actuel → Cible",
    "startCurrentTarget": "Départ → Actuel → Cible",
    "remaining": "Restant",
    "reached": "Objectif atteint ! 🎯",
    "etaLine": "À ce rythme ({rate} kg/semaine), tu y arrives dans ~{weeks} semaines",
    "etaTooFast": "Rythme rapide ({rate} kg/semaine). À revoir avec ton nutritionniste.",
    "etaProjection": "Projection",
    "weeks": "semaines",
    "wrongDirection": "Ton poids évolue dans le sens opposé à ton objectif.",
    "wrongDirectionHint": "Revois calories et entraînements avec ton nutritionniste.",
    "needMore": "Pèse-toi pendant au moins 2 semaines consécutives pour voir la projection.",
    "logFirst": "Enregistre d'abord ton poids actuel.",
    "invalid": "Saisis un poids valide entre 30 et 250 kg",
    "saved": "Poids cible enregistré",
    "cleared": "Objectif retiré",
    "clearBtn": "Retirer l'objectif",
    "editBtn": "Modifier",
    "milestones": "Sous-objectifs",
    "milestoneTitle": "Étape franchie ! 🎉",
    "milestoneDesc": "Tu es à {kg} kg — chaque 2 kg compte.",
    "milestoneFinalTitle": "Poids cible atteint ! 🎯",
    "milestoneFinalDesc": "Bravo, tu as atteint ton poids idéal."
  },
  "recipes": {
    "qrScanBtn": "Scanner QR",
    "qrScanTitle": "Scanner un code QR",
    "qrScanHint": "Vise le code QR d'un ami (recette ou repas)",
    "qrInvalid": "Code QR Solano non valide",
    "qrCameraError": "Caméra indisponible. Autorise l'accès à la caméra.",
    "quickActionQr": "Code QR",
    "qrTitle": "Partager par code QR",
    "qrHint": "Le scan ouvre directement la recette — dans l’app si elle est installée.",
    "qrCopyLink": "Copier le lien",
    "goalScore": {
      "title": "Score objectif",
      "goals": {
        "dimagrimento": "Perte de poids",
        "mantenimento": "Maintien",
        "massa": "Prise de muscle"
      },
      "bands": {
        "very_good": "Très adapté",
        "good": "Adapté",
        "conditional": "Partiellement adapté",
        "less_suited": "Peu adapté"
      },
      "reasons": {
        "protein_rich": "Riche en protéines",
        "satiating": "Rassasiant avec des calories modérées",
        "fiber_rich": "Riche en fibres",
        "veg_rich": "Forte part de légumes/fruits",
        "kcal_fits": "Calories adaptées à ce repas",
        "good_for_muscle": "Excellent repas pour la masse",
        "kcal_high_for_goal": "Un peu calorique pour ton objectif",
        "kcal_low_for_goal": "Un peu pauvre en calories pour la masse",
        "salt_high": "Teneur en sel assez élevée",
        "sugar_high": "Teneur en sucre assez élevée",
        "satfat_high": "Beaucoup de graisses saturées",
        "protein_low": "Pauvre en protéines",
        "over_budget_today": "Dépasse ton budget restant du jour",
        "balanced_ok": "Globalement équilibré"
      }
    },
    "nutritionBasisLabel": "Valeurs nutritionnelles par portion",
    "nutritionBasisScaled": "Valeurs nutritionnelles pour {n} portions",
    "seasoningEstimateHint": "Épices/sel « selon le goût » et ingrédients optionnels ne sont pas calculés exactement",
    "folderSauce": "Sauce / Vinaigrette",
    "collectionsTitle": "Collections",
    "collectionsNew": "Nouvelle",
    "collectionsCreateTitle": "Nouvelle collection",
    "collectionsEditTitle": "Modifier la collection",
    "collectionsNamePh": "Nom (ex. Meal prep)",
    "collectionsEmojiLabel": "Icône",
    "collectionsColorLabel": "Couleur",
    "collectionsCreateBtn": "Créer",
    "collectionsSaveBtn": "Enregistrer",
    "collectionsDeleteConfirm": "Supprimer la collection ? Tes recettes restent dans la bibliothèque.",
    "collectionsAddTo": "Ajouter à une collection",
    "collectionsAddToTitle": "Enregistrer dans les collections",
    "collectionsCreated": "Collection créée",
    "collectionsDeleted": "Collection supprimée",
    "sauceAiBtn": "Suggérer des sauces avec l'IA",
    "sauceAiHint": "Assorties à tes recettes et ton garde-manger — pauvres en sel, avec quantités exactes",
    "sauceAiDone": "3 nouvelles sauces/vinaigrettes créées",
    "partialEstimateBadge": "Valeurs nutritionnelles partiellement estimées",
    "highSaltWarning": "Teneur en sel élevée",
    "matchedCount": "{a} sur {b} ingrédients entièrement calculés",
    "reviewNeeded": "Valeurs incomplètes — vérifie les ingrédients",
    "reviewUnmatched": "Non reconnus",
    "fixBtn": "Vérifier et corriger les ingrédients",
    "editIngredients": "Modifier",
    "fillAmounts": "Compléter les quantités",
    "fillAmountsHint": "Certains ingrédients n'ont pas de quantité – les compléter avec des quantités et valeurs typiques de la base.",
    "fillAmountsDone": "{n} ingrédient(s) complété(s) avec des quantités typiques – à vérifier",
    "fillAmountsNone": "Tous les ingrédients ont déjà une quantité",
    "livePerServing": "par portion",
    "liveTotal": "total",
    "liveCalculating": "Calcul…",
    "fixTitle": "Corriger les ingrédients",
    "fixSubtitle": "Modifie les ingrédients jusqu'à ce qu'ils soient tous reconnus. À l'enregistrement, les valeurs nutritionnelles sont recalculées automatiquement.",
    "fixMatched": "Reconnu",
    "fixUnmatched": "Non reconnu — modifie le texte ou choisis un aliment de la base via la loupe",
    "fixNegligible": "Négligeable (eau/épice)",
    "fixPickFood": "Choisir dans la base",
    "fixSearchPlaceholder": "Rechercher un aliment…",
    "fixNoResults": "Aucun résultat",
    "fixSuggestion": "Tu voulais dire",
    "fixAdd": "Ajouter un ingrédient",
    "fixSearchDb": "Chercher",
    "fixUnknownCount": "{n} ingrédient(s) non reconnu(s) – surlignés, touche pour choisir dans la base",
    "fixServings": "Portions",
    "fixSave": "Enregistrer et recalculer",
    "fixSaving": "Calcul…",
    "fixSavedOk": "Recette mise à jour — valeurs recalculées",
    "fixSavedStillReview": "Enregistré — certains ingrédients ne sont toujours pas reconnus",
    "fixError": "Échec de la mise à jour",
    "cuisineTitle": "Cuisines souhaitées (optionnel)",
    "cuisineNames": {
      "asian": "Asiatique",
      "mediterranean": "Méditerranéenne",
      "oriental": "Orientale",
      "mexican": "Mexicaine",
      "indian": "Indienne",
      "japanese": "Japonaise",
      "thai": "Thaïlandaise",
      "southamerican": "Sud-américaine"
    },
    "verifiedBadge": "Valeurs nutritionnelles vérifiées",
    "infographicBtn": "Recette",
    "infographicBusy": "Création…",
    "infographicDone": "Infographie enregistrée !",
    "infographicServings": "portions",
    "infographicNutrition": "Valeurs par portion",
    "infographicIngredients": "Ingrédients principaux",
    "infographicSteps": "Préparation",
    "recipeMenuShare": "Partager",
    "recipeMenuDuplicate": "Dupliquer la recette",
    "recipeMenuDelete": "Supprimer",
    "showAllIngredients": "Voir tous les ingrédients",
    "linkCopied": "Lien copié",
    "difficultyEasy": "Facile",
    "difficultyMedium": "Moyen",
    "difficultyHard": "Difficile",
    "quickActionShare": "Partager",
    "shareMenuLink": "Partager le lien",
    "shareMenuLinkHint": "WhatsApp, Messages, e-mail …",
    "shareMenuSocial": "Partager sur les réseaux",
    "shareMenuSocialShort": "Social",
    "shareMenuSocialHint": "Image + texte pour Instagram, TikTok & co.",
    "socialShareTitle": "Partager sur les réseaux",
    "socialFormatSquare": "Carré 1:1",
    "socialFormatStory": "Story 9:16",
    "socialFormatPortrait": "Post 4:5",
    "socialFormatHintPortrait": "Post : choisis « Publication » dans le partage Instagram – le 4:5 passe sans recadrage.",
    "socialFullRecipeInApp": "Recette complète uniquement dans l’app",
    "socialCaption": "Texte IA",
    "socialCaptionBusy": "Rédaction du texte …",
    "socialCaptionError": "Impossible de créer le texte",
    "socialCaptionHint": "Instagram & TikTok ne reprennent pas le texte automatiquement – il est copié dans le presse-papiers au partage, il suffit de le coller.",
    "socialCaptionInClipboard": "Texte copié – colle-le dans l'app",
    "socialRegenerate": "Nouveau",
    "socialCopy": "Copier",
    "socialCopied": "Texte copié",
    "socialShareBtn": "Partager l'image",
    "socialBusy": "Création de l'image …",
    "socialDownloaded": "Image enregistrée",
    "socialMadeWith": "Créé avec Solano Essence",
    "socialPhotoFailed": "La photo de la recette n’a pas pu être intégrée – carte créée sans photo.",
    "socialFormatHintStory": "Story/Reel : choisis « Story » dans le partage Instagram – le 9:16 passe sans recadrage.",
    "socialFormatHintSquare": "Carré : maintiens l’image → enregistre dans Photos → publie comme post dans Instagram.",
    "socialLongPressHint": "Astuce : maintiens l'image pour l'enregistrer dans Photos.",
    "socialShareFailedHint": "Partage impossible – maintiens l'image pour l'enregistrer.",
    "quickActionShoppingList": "Liste de courses",
    "quickActionDuplicate": "Dupliquer",
    "addedToShoppingList": "Ingrédients ajoutés à la liste",
    "privacyPrivateDesc": "Visible uniquement par toi.",
    "privacyNutritionistDesc": "Partagée avec tes clients.",
    "privacyPublicDesc": "Visible par toute la communauté Solano.",
    "addedToDiaryFlash": "Ajouté au journal",
    "healthScoreTitle": "Health Score",
    "healthScoreGreat": "Très équilibré",
    "healthScoreGood": "Équilibré",
    "healthScoreImprove": "À revoir",
    "goalFitTitle": "Adapté pour",
    "goalWeightLoss": "Perte de poids",
    "goalMaintenance": "Maintien",
    "goalMuscleGain": "Prise de muscle",
    "aiEstimateBadge": "Valeurs nutritionnelles estimées",
    "goalPortionDependent": "selon la portion et le bilan du jour",
    "aiCoachBtn": "AI Coach",
    "aiCoachTitle": "Modifier la recette avec l'IA",
    "aiCoachDesc": "Décris comment tu veux modifier la recette. L'IA génèrera une nouvelle version avec des ingrédients, étapes et macros mis à jour.",
    "aiCoachPlaceholder": "Ex. rends-la végétarienne / +protéines / sans lactose / 700 kcal / pour 4",
    "aiCoachRun": "Générer avec l'IA",
    "aiCoachRunning": "L'IA travaille…",
    "aiCoachDone": "Recette modifiée par l'IA",
    "aiCoachError": "L'IA n'a pas pu modifier la recette",
    "aiCoachBadge": "Modifiée par IA",
    "aiCoachRestore": "Restaurer l'original",
    "aiCoachChipVeggie": "Végétarien",
    "aiCoachChipHiPro": "Plus de protéines",
    "aiCoachChipNoLactose": "Sans lactose",
    "aiCoachChipKcal": "700 kcal",
    "aiCoachChipServings": "Pour 4",
    "aiCoachChipCheap": "Moins cher",
    "shareExpired": "Le lien a expiré.",
    "shareNotFound": "Recette partagée introuvable.",
    "microFiber": "Fibres",
    "trBatchDone": "{n} recettes traduites 🎉",
    "photoBatchDone": "{n} photos générées 🎉",
    "aiGeneratedOk": "5 recettes générées avec l'IA !",
    "aiError": "Erreur IA",
    "favoriteAdded": "Ajouté aux favoris",
    "favoriteRemoved": "Retiré des favoris",
    "confirmDeleteOther": "Supprimer la recette d'un autre utilisateur ? Cette action est irréversible.",
    "deleted": "Recette supprimée",
    "addedToDiary": "Ajouté au journal !",
    "recomputedOk": "Macros recalculées",
    "recomputeError": "Recalcul impossible",
    "adaptInvalidKcal": "Saisis une valeur kcal valide",
    "adaptedOk": "Recette adaptée",
    "adaptError": "Adaptation impossible",
    "title": "Recettes",
    "subtitle": "Enregistre tes recettes préférées avec calories et macros",
    "photoBatchRunning": "Génération {done}/{total}…",
    "photoBatchStart": "Générer les photos IA ({n} manquantes)",
    "importInstagram": "Depuis Instagram",
    "aiGenerating": "Génération…",
    "aiGenerateBtn": "Générer 5 avec l'IA",
    "newRecipe": "Nouvelle recette",
    "trBatchRunning": "Traduction {done}/{total}…",
    "trBanner": "{n} recettes pas encore dans ta langue",
    "trBatchBtn": "Tout traduire",
    "emptyLibrary": "Pas encore de recettes",
    "emptyFavorites": "Pas encore de favoris",
    "emptyFolder": "Rien ici pour l'instant",
    "emptyFavoritesHint": "Touche le cœur sur une recette pour l'enregistrer ici et la réutiliser en un geste.",
    "emptyFolderHint": "Ajoute une recette à ce dossier ou choisis-en un autre.",
    "libraryBadge": "Bibliothèque",
    "byAuthor": "par",
    "visibilityPrivateShort": "Privée",
    "visibilityNutritionistShort": "Nutritionniste",
    "favoriteRemove": "Retirer des favoris",
    "favoriteAdd": "Ajouter aux favoris",
    "microSugar": "Sucres",
    "microSat": "Sat.",
    "microSalt": "Sel",
    "addToDiary": "Ajouter au journal",
    "aiPromptTitle": "Générer des recettes avec l'IA",
    "aiPromptDesc": "Décris ce que tu veux (optionnel). L'IA générera 5 recettes correspondant à ta demande.",
    "aiPromptPlaceholder": "ex. menu sous 500 kcal, sans gluten, rapide à préparer…",
    "aiChipUnder500": "sous 500 kcal",
    "aiChipHighProtein": "riche en protéines",
    "aiChipVegetarian": "végétarien",
    "aiChipGlutenFree": "sans gluten",
    "aiChipQuick": "prêt en 15 min",
    "aiPromptGenerate": "Générer 5 recettes",
    "adaptTitle": "Adapter la recette",
    "adaptDesc": "Recette actuelle : {current} kcal par portion. Saisis tes kcal cibles et j'ajusterai les quantités.",
    "adaptTargetLabel": "Kcal cibles par portion",
    "adapting": "Adaptation…",
    "adaptConfirm": "Adapter",
    "photoGenerated": "Photo générée",
    "photoGenerating": "Génération de la photo…",
    "photoRegenerate": "Régénérer la photo IA",
    "photoGenerate": "Générer une photo IA",
    "recomputing": "Recalcul…",
    "recomputeBtn": "Recalculer",
    "adaptBtn": "Adapter les kcal",
    "restoreOriginal": "Restaurer l'original",
    "ingredients": "Ingrédients",
    "scaledForPeople": "Ajusté pour {n} personnes",
    "preparation": "Préparation",
    "visibilityTitle": "Qui peut voir cette recette",
    "visibilityPrivate": "Moi uniquement",
    "visibilityPublic": "Tout le monde",
    "visibilityUpdated": "Visibilité mise à jour",
    "useAdjustedNotice": "Les calories seront recalculées depuis les ingrédients ajustés",
    "folderBreakfast": "Petit-déj",
    "folderSnack": "Collation",
    "folderLunch": "Déjeuner",
    "folderAfternoon": "Goûter",
    "folderDinner": "Dîner",
    "addBtn": "Ajouter",
    "folderAll": "Toutes",
    "folderFavorites": "Favoris",
    "recipeSingular": "recette",
    "recipePlural": "recettes"
  },
  "diary": {
    "openCamera": "Ouvrir l'appareil photo",
    "uploadPhoto": "Importer une photo",
    "hintPlaceholder": "Ex. 35g farine, 80g œuf, 80g banane",
    "hintCompute": "Calculer les valeurs nutritionnelles",
    "photoAttached": "Photo ajoutée",
    "quickEntryLabel": "Saisie rapide",
    "hintComputed": "Valeurs calculées à partir de ta liste",
    "hintComputedPartial": "{matched} sur {total} ingrédients reconnus — valeurs peut-être incomplètes",
    "splitIngredients": "Séparer en ingrédients",
    "splitIngredientsHint": "Chaque ingrédient modifiable – macros estimées selon la part en grammes (≈), total inchangé",
    "splitDone": "{n} ingrédients créés",
    "lookupIngredients": "Reprendre les valeurs de la base de données",
    "lookupIngredientsHint": "Remplace les valeurs estimées (≈) par de vraies valeurs pour 100 g",
    "lookupRow": "Depuis la base",
    "lookupDone": "{n} ingrédients repris de la base de données",
    "lookupPartial": "{found} ingrédients sur {total} trouvés – le reste reste estimé",
    "portionUncertain": "L'IA n'est pas sûre des portions — vérifie et corrige les grammes avant d'enregistrer.",
    "breakfast": "Petit-déjeuner",
    "lunch": "Déjeuner",
    "dinner": "Dîner",
    "snack": "Collation",
    "newCommentOne": "1 nouveau commentaire",
    "newCommentMany": "{count} nouveaux commentaires",
    "newCommentTap": "Touche pour voir le feedback",
    "logAsMeal": "Ajouter au repas d'aujourd'hui",
    "addToDiary": "Ajouter au journal",
    "afternoon": "Goûter",
    "title": "Journal du jour",
    "journalTitle": "Journal du jour",
    "aiChefStep1": "J'analyse ton repas…",
    "aiChefStep2": "Je reconnais les aliments…",
    "aiChefStep3": "Je calcule les calories et macros…",
    "aiChefStep4": "Presque prêt…",
    "aiChefStep5": "Ton repas est bientôt prêt…",
    "aiChefDone": "Ton repas est prêt.",
    "barcodeNudgeTitle": "Produit emballé détecté",
    "barcodeNudgeBody": "Scanne le code-barres pour les valeurs exactes",
    "barcodeNudgeCta": "Scanner →",
    "journalSubtitle": "Comment te sens-tu ? Comment s'est passée la journée ?",
    "journalPlaceholder": "Notes libres sur la journée, entraînement, énergie, envies…",
    "journalSaved": "Sauvegardé",
    "journalVoiceRec": "Enregistrement",
    "journalVoiceTranscribing": "Transcription…",
    "journalVoiceEmpty": "Aucune parole détectée",
    "journalReplies": "Réponses de la nutritionniste",
    "journalSaveEntry": "Enregistrer",
    "journalTodayEntries": "Entrées du jour",
    "journalMorning": "Matin",
    "journalAfternoon": "Après-midi",
    "journalEvening": "Soir",
    "journalPickSomething": "Choisis une humeur ou écris quelque chose",
    "mealVerdictGood": "Excellent",
    "mealVerdictWarn": "Bon",
    "mealVerdictBad": "À revoir",
    "verdictExplainGood": "Top : repas bien équilibré.",
    "verdictExplainWarn": "OK — petites améliorations possibles :",
    "verdictExplainBad": "À revoir — au-dessus des seuils sur :",
    "verdictReason": {
      "sugar": "Trop de sucres — réduire boissons/dessert",
      "salt": "Trop de sel — réduire les aliments transformés",
      "satFat": "Trop de graisses saturées — préférer huile d'olive",
      "heavySnack": "Collation trop copieuse — vise ≤ 200 kcal",
      "lowProtein": "Peu de protéines — ajoute des protéines maigres",
      "lowFiber": "Peu de fibres — ajoute légumes ou céréales complètes",
      "tooLight": "Un peu léger pour un repas principal",
      "tooHeavy": "Un peu copieux — réduis les portions",
      "emptyCarbs": "Uniquement des glucides simples — ajoute protéines ou fibres",
      "lowProteinOrFiber": "Peu de protéines ou fibres",
      "heavyBreakfast": "Petit-déjeuner un peu copieux",
      "balancedMain": "Repas principal bien équilibré",
      "lightSnack": "Collation légère et équilibrée",
      "goodBreakfast": "Bon petit-déjeuner",
      "neutral": "Neutre"
    },
    "verdictAdvice": {
      "sugar": "Remplace les boissons/desserts sucrés par des fruits frais. Recettes avec < 8 g de sucre.",
      "salt": "Réduis les aliments transformés (charcuterie, sauces, snacks salés). Recettes avec < 1 g de sel.",
      "satFat": "Utilise l'huile d'olive au lieu du beurre. Recettes avec graisses saturées < 3 g.",
      "heavySnack": "Choisis des collations sous 200 kcal (fruits, yaourt grec, oléagineux portionnés).",
      "lowProtein": "Ajoute 100–150 g de poulet, poisson, œufs ou légumineuses. Recettes avec protéines ≥ 25 g.",
      "lowFiber": "Ajoute légumes crus/cuits, légumineuses ou céréales complètes. Recettes avec fibres ≥ 8 g.",
      "tooLight": "Recettes 400–700 kcal pour tenir jusqu'au repas suivant.",
      "tooHeavy": "Réduis les portions de glucides et matières grasses. Recettes équilibrées ≤ 550 kcal.",
      "emptyCarbs": "Équilibre avec des protéines (yaourt, œufs) ou fibres (légumes, fruits).",
      "lowProteinOrFiber": "Ajoute des protéines maigres OU des fibres pour équilibrer.",
      "heavyBreakfast": "Petit-déjeuner ≤ 450 kcal : fruits + yaourt grec + flocons d'avoine complets."
    },
    "verdictSheetPraise": "Bien joué — ce repas est bien équilibré pour tes objectifs.",
    "verdictRecipesSuggest": "Recettes qui peuvent aider",
    "verdictNoRecipes": "Aucune recette correspondante dans ta bibliothèque. Essaie-en une nouvelle depuis le Frigo !",
    "addBtn": "Ajouter un repas",
    "empty": "Aucun repas enregistré",
    "loading": "Chargement…",
    "portionLabel": "Portion",
    "portionHint": "Ajuste les grammes : les macros s'adaptent",
    "swipeEdit": "Modifier",
    "swipeDuplicate": "Dupliquer",
    "swipeDelete": "Supprimer",
    "mealDuplicated": "Repas dupliqué dans aujourd'hui",
    "yourMeals": "Tes repas",
    "yourMealsSubtitle": "Repas et ingrédients des 7 derniers jours – touche pour copier",
    "favorites": "Favoris",
    "favoriteAdd": "Marquer comme favori",
    "favoriteRemove": "Retirer des favoris",
    "favoriteAdded": "Ajouté aux favoris",
    "favoriteRemoved": "Retiré des favoris",
    "favLongPressHint": "Appui long = enregistrer directement",
    "favQuickLogged": "Favori enregistré directement",
    "summaryTitle": "Résumé du repas",
    "kcalShort": "kcal",
    "proteinShort": "Prot.",
    "carbsShort": "Gluc.",
    "fatShort": "Lip.",
    "fiberShort": "Fibres",
    "mealLogged": "Repas enregistré",
    "journalVoicePermDenied": "Accès au micro refusé",
    "voiceNoteMax": "Enregistrer une note vocale (max 15 s)",
    "quickFood": "Aliment",
    "quickPhoto": "Photo IA",
    "deleted": "Repas supprimé",
    "undo": "Annuler",
    "restored": "Suppression annulée",
    "allDuplicated": "{n} repas copiés",
    "subtitle": "Enregistre ce que tu manges.",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "noMealsYesterday": "Aucun repas enregistré hier",
    "duplicateAll": "Tout copier",
    "duplicateFromYesterday": "Copier d'hier",
    "totalEst": "Total du jour :",
    "addMeal": "Ajouter un repas",
    "addMealHint": "Choisis comment enregistrer ce repas",
    "noneForDate": "Aucun repas enregistré à cette date.",
    "saveAsRecipe": "Enregistrer comme recette",
    "saveAsRecipeHint": "{n} entrées · {kcal} kcal au total. Enregistre ce plat comme ta propre recette — la prochaine fois, il suffira d'enregistrer une portion.",
    "recipeNamePh": "Nom de la recette (p. ex. Lasagnes de mamie)",
    "recipeNameRequired": "Merci d'indiquer un nom de recette.",
    "recipeServings": "Donne portions",
    "recipePerServing": "≈ {kcal} kcal par portion",
    "recipeNotePh": "Préparation / notes (facultatif)",
    "recipeUsePhoto": "Reprendre la photo de l'entrée",
    "recipePhotoAuto": "Cette photo devient automatiquement l'image de la recette",
    "recipeSaveBtn": "Enregistrer la recette",
    "recipeSaved": "Recette enregistrée ! Retrouve-la dans l'onglet « Recettes » 📖",
    "autoSortedInto": "Ajoutée à :",
    "recipeKeepMyPortion": "Ne garder que ma portion dans le journal",
    "recipeMyPortions": "Mes portions",
    "recipeMyPortionHint": "Les entrées sont remplacées par 1 entrée d'≈ {kcal} kcal",
    "recipeSavedPortion": "Recette enregistrée — ton journal n'affiche plus que ta portion 📖",
    "pctOfDay": "{n} % de l'objectif quotidien",
    "voiceError": "Je n'ai pas compris, réessaie",
    "voiceOk": "C'est fait ! Ajuste si besoin, puis enregistre.",
    "voicePermDenied": "Autorisation micro requise",
    "aiOk": "Repas reconnu ! Ajuste si besoin, puis enregistre.",
    "aiError": "Photo non analysable. Réessaie ou saisis manuellement.",
    "wrongMatchPrompt": "Comment cet aliment devrait-il s'appeler ?",
    "wrongMatchOk": "Merci ! Correction enregistrée — on apprend de ça.",
    "wrongMatchError": "Envoi de la correction impossible. Réessayer ?",
    "hintReanalyzed": "Analyse mise à jour avec ton indice",
    "recomputeError": "Recalcul impossible — vérifie noms/poids",
    "recomputeOk": "Macros recalculées",
    "foodNotRecognized": "Non reconnu (0 kcal)",
    "foodPickFromDb": "choisir dans la base",
    "describe": "Décris ce que tu as mangé",
    "mealUpdated": "Repas mis à jour",
    "voiceAnalyzing": "Analyse de ce que tu as dit…",
    "voiceListening": "J'écoute…",
    "voiceAnalyzingHint": "Un instant, transcription…",
    "voiceListeningHint": "Décris ton repas à voix haute. Touche « Stop » quand tu as fini.",
    "voiceStop": "Stop",
    "aiPhoto": "Analyser avec l'IA",
    "aiPhotoDesc": "Prends ton plat en photo : l'IA reconnaît les aliments et calcule kcal, macros et micronutriments.",
    "portionTipTitle": "Astuce pour une meilleure estimation des portions",
    "portionTipBody": "Inclus une main, une fourchette ou une pièce sur la photo — ça aide l'IA à estimer les grammes plus précisément.",
    "portionTipDismiss": "Compris",
    "aiRetryTitle": "Analyse de la photo échouée",
    "aiRetryHelp": "Ajoute un indice ci-dessous pour aider l'IA, ou réessaie directement.",
    "aiRetryBtn": "Réessayer",
    "hintLabel": "Aide l'IA",
    "hintOptional": "(optionnel)",
    "hintReanalyze": "Ré-analyser avec l'indice",
    "editMeal": "Modifier le repas",
    "meal": "Repas",
    "recognizedFoods": "Aliments reconnus",
    "recomputing": "Recalcul…",
    "recompute": "Recalculer les macros",
    "foodNamePh": "ex. Courgettes grillées",
    "wrongMatchAria": "Signaler une mauvaise correspondance",
    "wrongMatch": "Mauvaise correspondance ?",
    "addFood": "Ajouter un aliment",
    "aiAnalyzing": "Analyse…",
    "descPh": "ex. 80 g de pâtes complètes, tomate, huile d'olive",
    "notesTitle": "Instructions et notes",
    "notesPh": "Notes (faim, humeur, sport…)",
    "save": "Enregistrer"
  },
  "clientDetail": {
    "heroSection": "Indicateurs & Coach AI",
    "tabOverview": "Aperçu",
    "tabNutrition": "Nutrition",
    "tabProgress": "Progrès",
    "tabProfile": "Profil",
    "tileAdherence": "Adhérence",
    "tileAdherenceSub": "14 jours",
    "tileJournal": "Journal client",
    "tileJournalSub": "30 jours",
    "tileProfile": "Profil",
    "tileProfileSub": "Objectif, âge, taille",
    "tileTrends": "Tendances",
    "tileTrendsSub": "Poids & adhérence",
    "tileWearable": "Wearable",
    "tileWearableSub": "VFC, sommeil, pas",
    "tileDiary": "Journal alimentaire",
    "tileDiarySub": "Repas & commentaires",
    "recentLogs": "Journal alimentaire du client",
    "noLogs": "Aucun enregistrement.",
    "noLogsForDay": "Aucun log pour ce jour.",
    "jumpToDay": "Aller au jour",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "weeklyPreview": "PDF hebdomadaire",
    "weeklySend": "Envoyer",
    "weeklyLoading": "Génération du PDF…",
    "weeklySending": "Envoi en cours…",
    "weeklySent": "Rapport envoyé par email",
    "quickNotes": "Notes rapides",
    "clientReplyLabel": "Réponse du client",
    "qn_great": "Excellent repas",
    "qn_portion": "Attention à la portion",
    "qn_veggies": "Ajoute des légumes",
    "qn_protein": "Plus de protéines",
    "qn_water": "Bois plus d'eau",
    "qn_carbs": "Réduis les glucides",
    "qn_timing": "Revois les horaires des repas",
    "qn_sugar": "Attention au sucre",
    "commentTitle": "Commenter ce repas",
    "commentLabel": "Ton commentaire (visible par le client)",
    "commentPlaceholder": "Écris un bref retour au client…",
    "commentSaved": "Commentaire envoyé au client",
    "commentCleared": "Commentaire supprimé",
    "backClients": "Clients",
    "updatePlan": "Mettre à jour le plan",
    "createPlan": "Créer un plan",
    "currentPlan": "Plan actuel",
    "noPlan": "Aucun plan attribué.",
    "planTargetsTitle": "Objectifs du plan",
    "avgIntakeTitle": "Apport moyen (7 derniers jours)",
    "microsTitle": "Micronutriments moyens",
    "avgIntakeEmpty": "Aucun repas enregistré ces 7 derniers jours.",
    "noLogsForBadge": "Aucune entrée",
    "tapForDetails": "Touche pour les détails",
    "hasComment": "A un commentaire",
    "profile": "Profil",
    "goal": "Objectif",
    "activity": "Activité",
    "sport": "Sport",
    "height": "Taille",
    "startingWeight": "Poids de départ",
    "kcalTarget": "Objectif kcal",
    "allergies": "Allergies",
    "monthlyReport": "Rapport mensuel",
    "printPdf": "Imprimer / PDF",
    "client": "Client",
    "period": "Période",
    "startWeight": "Poids initial",
    "endWeight": "Poids final",
    "delta": "Delta",
    "diaryDays": "Jours de journal",
    "avgKcalDay": "Kcal moy./jour",
    "avgWaterDay": "Eau moy./jour",
    "glasses": "verres",
    "avgSleep": "Sommeil moyen",
    "avgHrv": "VFC moyenne",
    "progressPhotosTitle": "Photos de progrès",
    "reportFooter": "Repas totaux : {meals} · Photos de progrès : {photos} · FC repos moyenne : {rhr}",
    "lastEntry": "Dernière entrée",
    "mWeight": "Poids",
    "mScore": "Score",
    "mAdherence": "Adhérence",
    "mStatus": "Statut",
    "ctaPlan": "Modifier le plan",
    "attentionTitle": "Attention",
    "cadenceSaved": "Cadence mise à jour",
    "checkinDone": "Check-in enregistré",
    "cadWeekly": "Hebdomadaire",
    "cadBiweekly": "Bimensuel",
    "cadMonthly": "Mensuel",
    "checkinTitle": "Check-in client",
    "lastCheckin": "Dernier check-in",
    "nextCheckin": "Prochain check-in",
    "cadence": "Cadence",
    "lastNote": "Dernière note",
    "notePh": "Qu'est-ce qui a bien marché cette semaine ? Que manque-t-il ?",
    "addNote": "Ajouter une note",
    "completeCheckin": "Terminer le check-in"
  },
  "groupChallenges": {
    "section": "Défis de groupe",
    "new": "Nouveau",
    "auto": "AUTO",
    "manual": "MANUEL",
    "autoTip": "Vérifié automatiquement à partir des données de l'app",
    "manualTip": "Check-in manuel (basé sur la confiance)",
    "daysRemaining": "{n} jours restants",
    "lastDay": "Dernier jour !",
    "today": "Aujourd'hui",
    "yourProgress": "Ta progression",
    "daysUnit": "jours",
    "wearableHint": "Connecte ta montre (Vital.io) pour la vérification automatique",
    "targetReached": "Objectif atteint aujourd'hui",
    "needMore": "Encore {n} {unit}",
    "markDone": "Marquer aujourd'hui comme fait",
    "doneToday": "Fait aujourd'hui",
    "noOneCheckedIn": "Personne n'a encore validé",
    "leaderInFront": "en tête",
    "newTitle": "Nouveau défi de groupe",
    "newDesc": "Choisis un objectif, une durée et invite tes amis.",
    "chooseGoal": "Choisis un objectif",
    "customTitleLabel": "Défi personnalisé",
    "customHint": "Manuel · check-in basé sur la confiance",
    "autoDisclaimer": "Les défis avec badge AUTO sont vérifiés automatiquement à partir des données enregistrées dans l'app (eau, entraînements, repas, montre). Impossible de tricher.",
    "fldTitle": "Titre",
    "fldEmoji": "Emoji",
    "fldTargetPerDay": "Objectif/jour",
    "fldUnit": "Unité",
    "titlePlaceholder": "ex. Méditation du matin",
    "unitPlaceholder": "ex. minutes",
    "target": "Objectif",
    "duration": "Durée",
    "d7": "7 jours",
    "d30": "30 jours",
    "inviteFriends": "Inviter des amis",
    "selectedCount": "({n} sélectionnés)",
    "create": "Créer le défi",
    "creating": "Création…",
    "emptyTitle": "Aucun défi actif",
    "emptyDesc": "Défie tes amis : 10k pas, 5 portions de légumes, entraînements hebdomadaires…",
    "emptyCta": "Créer le premier défi",
    "inviteBadge": "Invitation au défi",
    "inviteDetails": "{days} jours · {n} déjà dedans",
    "accept": "Accepter",
    "decline": "Refuser",
    "detailSubtitle": "Classement par jours complétés",
    "detailStats": "{d} jours · {n} participants",
    "you": "Toi",
    "leave": "Quitter le défi",
    "del": "Supprimer le défi",
    "confirmDelete": "Supprimer définitivement le défi pour tous les participants ?",
    "confirmLeave": "Veux-tu quitter ce défi ?",
    "toastCreated": "Défi créé !",
    "toastCheckinDone": "Bravo ! Check-in enregistré 🎯",
    "toastCheckinRemoved": "Check-in annulé",
    "toastAccepted": "Défi accepté !",
    "toastDeleted": "Défi supprimé",
    "toastLeft": "Tu as quitté le défi",
    "toastAutoNotYet": "Défi auto-vérifié : encore {n} {unit}. Enregistre les données dans l'app !",
    "toastError": "Erreur",
    "loading": "Chargement des défis…"
  },
  "calc": {
    "jobTitle": "Travail et quotidien",
    "jobSitting": "Principalement assis (bureau, télétravail)",
    "jobStanding": "Debout / mixte (vente, enseignement)",
    "jobPhysical": "Physiquement actif (artisanat, soins)",
    "stepsTitle": "Pas par jour",
    "trainTitle": "Entraînements par semaine",
    "factorLabel": "Facteur d'activité",
    "deficitTitle": "Rythme de perte de poids",
    "deficitSoft": "Doux",
    "deficitModerate": "Modéré",
    "deficitFast": "Rapide",
    "deficitCustom": "Personnalisé",
    "goalCustom": "Personnalisé",
    "sumHint": "Total : {sum}% — ajuste la somme à 100%",
    "etaWeeks": "≈ {weeks} semaines jusqu'à {target} kg",
    "etaNote": "Simple estimation — le poids cible n'influence pas le calcul des calories.",
    "dblCountHint": "Ton entraînement est déjà inclus dans le facteur d'activité — les calories d'entraînement ne sont pas ajoutées au budget quotidien.",
    "reviewTitle": "Bilan d'objectif",
    "reviewBody": "Depuis {days} jours : {actual} kg/semaine (prévu : {expected} kg/semaine).",
    "reviewSuggestDown": "Suggestion : réduis ton objectif quotidien de 100 kcal à {kcal} kcal.",
    "reviewSuggestUp": "Suggestion : augmente ton objectif quotidien de 100 kcal à {kcal} kcal.",
    "reviewApply": "Appliquer",
    "reviewLater": "Plus tard",
    "reviewApplied": "Nouvel objectif quotidien enregistré",
    "customAdj": "Ajuster déficit/surplus individuellement",
    "customAdjHint": "Fais glisser pour modifier le pourcentage par rapport au maintien (-30 % déficit ↔ +30 % surplus).",
    "manualLink": "Tu connais déjà ton objectif calorique ? Saisis-le manuellement",
    "maintenance": "Besoins de maintien",
    "goalLabel": "Objectif",
    "recommended": "Objectif quotidien recommandé",
    "applyComputed": "Appliquer l'objectif calculé",
    "adjustManually": "Ajuster manuellement",
    "missing": "Remplis tous les champs",
    "gender": "Sexe",
    "age": "Âge",
    "height": "Taille",
    "weight": "Poids",
    "activity": "Niveau d'activité",
    "goal": "Objectif",
    "applied": "Objectifs enregistrés dans ton profil",
    "title": "Calculateur de calories et macros",
    "subtitle": "Sur la base de tes données, j'estime tes besoins quotidiens.",
    "targetWeight": "Poids cible",
    "targetWeightHint": "Optionnel · apparaît dans Progrès avec une projection ETA",
    "yourNeeds": "Tes besoins quotidiens",
    "day": "jour",
    "recompute": "Recalculer avec les nouvelles valeurs",
    "calculate": "Calculer",
    "goalCut": "Sèche",
    "goalMaintain": "Maintien",
    "goalPerf": "Performance",
    "goalBulk": "Prise de masse",
    "actSedentary": "Sédentaire",
    "actLight": "Léger",
    "actModerate": "Modéré",
    "actIntense": "Intense",
    "actAthlete": "Athlète",
    "ctaTitle": "Tu ne sais pas combien de kcal il te faut ?",
    "ctaHint": "Calcul automatique adapté à toi"
  },
  "nutriPlan": {
    "buttonShort": "Plan",
    "title": "Plan nutritionnel",
    "subtitle": "Définir les objectifs quotidiens pour",
    "client": "Client",
    "selfLabel": "toi",
    "historyTitle": "Historique des objectifs",
    "byCoach": "Coach",
    "bySelf": "Toi",
    "modeAuto": "Calcul automatique",
    "modeManual": "Manuel",
    "autoTitle": "Calcul Mifflin-St Jeor",
    "formulaTitle": "Formule BMR",
    "fMifflin": "Mifflin-St Jeor",
    "fMifflinHint": "Recommandé · général",
    "fHarris": "Harris-Benedict",
    "fHarrisHint": "Rev. 1984 · classique",
    "fKatch": "Katch-McArdle",
    "fKatchHint": "Nécessite % de graisse",
    "fCunningham": "Cunningham",
    "fCunninghamHint": "Athlètes · % de graisse",
    "bodyFat": "% masse grasse",
    "bodyFatHint": "3–60% · requis pour Katch/Cunningham",
    "needBodyFat": "Saisir le % de masse grasse (3–60)",
    "fallbackToMifflin": "% graisse manquant → utilisation de Mifflin-St Jeor",
    "customAdj": "Ajustement kcal manuel",
    "customAdjHint": "Remplacer le préréglage (-30% déficit ↔ +30% surplus)",
    "calculate": "Calculer les macros",
    "calcDone": "Valeurs mises à jour — modifiez si besoin",
    "presetTitle": "Répartition macro",
    "presetBalanced": "Équilibré",
    "presetLowCarb": "Low Carb",
    "presetHighProt": "High Protein",
    "presetCustom": "Personnalisé",
    "needKcalForPreset": "Saisir d'abord les kcal",
    "targetsTitle": "Objectifs quotidiens",
    "fiber": "Fibres",
    "water": "Eau",
    "microsTitle": "Micronutriments",
    "optional": "optionnel",
    "sodium": "Sodium",
    "calcium": "Calcium",
    "iron": "Fer",
    "vitD": "Vitamine D",
    "notifyLabel": "Notifier le client",
    "notifyHint": "Il recevra une notification push avec les nouvelles valeurs",
    "saveAndActivate": "Enregistrer & activer",
    "saved": "Plan enregistré",
    "savedPushed": "Plan enregistré · client notifié",
    "invalidKcal": "kcal doit être entre 800 et 6000",
    "macroSumWarn": "Somme macro : {sum}% (vérifiez les valeurs)"
  },
  "supplements": {
    "title": "Rappels de suppléments",
    "atTime": "à {time}",
    "moreCount": "{n} autres",
    "subtitleEmpty": "Toucher pour ajouter",
    "addBtn": "Ajouter un supplément",
    "newTitle": "Nouveau supplément",
    "editTitle": "Modifier",
    "presetsLabel": "Préréglages",
    "nameLabel": "Nom",
    "namePlaceholder": "ex. Magnésium 400mg",
    "timeLabel": "Heure",
    "daysLabel": "Jours",
    "everyDay": "Chaque jour",
    "weekdays": "Lun-Ven",
    "weekend": "Week-end",
    "active": "actifs",
    "needName": "Nom requis",
    "needDay": "Choisir au moins un jour",
    "saved": "Enregistré",
    "confirmDelete": "Supprimer ce rappel ?",
    "emptyState": "Aucun supplément. Ajoutez le premier !",
    "streakDays": "jours",
    "takenToday": "Pris aujourd'hui",
    "markTakenToday": "Marquer comme pris aujourd'hui",
    "d": {
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mer",
      "thu": "Jeu",
      "fri": "Ven",
      "sat": "Sam",
      "sun": "Dim"
    }
  },
  "privacy": {
    "title": "Confidentialité & mentions légales",
    "sections": {
      "privacy": "Politique de confidentialité",
      "beta": "Avertissement important",
      "medical": "Avertissement médical",
      "consents": "Gérer les consentements",
      "delete": "Supprimer le compte et les données",
      "contact": "Contact / demande de confidentialité"
    },
    "exportPdf": "Exporter en PDF"
  },
  "addMeal": {
    "addPhoto": "Ajouter une photo",
    "addPhotoSub": "Photographiez votre repas",
    "tbShare": "Partager",
    "tbQr": "QR",
    "tbFav": "Favori",
    "tbDuplicate": "Dupliquer",
    "tbPhoto": "Photo",
    "tbClear": "Effacer",
    "tbClose": "Fermer",
    "favoriteAdded": "Ajouté aux favoris",
    "favoriteRemoved": "Retiré des favoris",
    "duplicated": "Repas dupliqué",
    "duplicatePickTitle": "Dupliquer un repas",
    "duplicatePickSubtitle": "Choisissez un repas récent à réutiliser",
    "duplicatePickEmpty": "Aucun repas récent à dupliquer",
    "quickLogTitle": "Journal rapide",
    "sauceTitle": "Ajouter une sauce ?",
    "quickLogSubtitle": "Enregistrez un favori en un geste ou dupliquez un repas récent",
    "favTab": "Favoris",
    "recentTab": "Récents",
    "favPickEmpty": "Aucun favori — enregistrez un repas avec l'icône cœur",
    "favTapToLog": "Touchez pour enregistrer",
    "favLogged": "« {name} » enregistré",
    "duplicateFromDiary": "Dupliquer depuis le journal",
    "shareTapToOpen": "Touchez le lien pour l'ouvrir dans votre appli Solano Essence :",
    "sharedOk": "Recette partagée",
    "sharedCopied": "Lien copié — collez-le dans WhatsApp",
    "imported": "Recette importée depuis le lien",
    "shareExpired": "Le lien a expiré (validité 90 jours)",
    "shareNotFound": "Recette introuvable",
    "eatWhereTitle": "Où avez-vous mangé ?",
    "eatHome": "À la maison",
    "eatOut": "À l'extérieur",
    "eatHomeHint": "Les ingrédients correspondants sont automatiquement déduits du garde-manger.",
    "eatOutHint": "Repas à l'extérieur — rien n'est déduit du garde-manger."
  },
  "features": {
    "title": "Mes fonctionnalités",
    "subtitle": "Choisissez les outils à afficher sur votre tableau de bord",
    "summary": "{on}/{total} actives",
    "enabled": "Fonction activée",
    "disabled": "Fonction désactivée",
    "footnote": "Vous pouvez modifier ces paramètres à tout moment. Les fonctions désactivées ne feront plus apparaître de widgets, de rappels ou de notifications.",
    "items": {
      "water": {
        "label": "Eau quotidienne",
        "desc": "Suivez les verres et ml d'eau"
      },
      "weight": {
        "label": "Poids & tour de taille",
        "desc": "Enregistrez le poids et les mesures"
      },
      "sleep": {
        "label": "Sommeil & VFC",
        "desc": "Synchronisez la durée de sommeil et la variabilité cardiaque"
      },
      "steps_wearable": {
        "label": "Pas & wearable",
        "desc": "Pas quotidiens depuis Apple Health / Fitbit / Garmin"
      },
      "workouts": {
        "label": "Entraînements",
        "desc": "Enregistrez les séances et les calories brûlées"
      },
      "supplements": {
        "label": "Compléments",
        "desc": "Rappels et validations pour les compléments"
      },
      "gamification": {
        "label": "Gamification",
        "desc": "Points, badges, niveaux et séries"
      },
      "pantry": {
        "label": "Garde-manger",
        "desc": "Gérez les ingrédients à la maison"
      },
      "plate_solano": {
        "label": "Assiette Solano",
        "desc": "Répartition 50/25/25 (légumes/protéines/glucides)"
      },
      "mediterranean_score": {
        "label": "Score méditerranéen",
        "desc": "Adhésion au régime méditerranéen"
      },
      "coach_ai": {
        "label": "Coach IA",
        "desc": "Suggestions et retours automatiques de l'IA"
      }
    }
  },
  "workouts": {
    "last30": "30 derniers jours",
    "settingKcalInBudgetLabel": "Par défaut pour les nouveaux jours : ajouter les kcal brûlées au budget",
    "settingKcalInBudgetHelp": "Ex. 2000 kcal + 300 brûlées = 2300 disponibles. Modifiable jour par jour sur le tableau de bord.",
    "wearableReadOnly": "Synchronisé depuis le wearable — non modifiable ici",
    "needName": "Ajoute un nom",
    "saved": "Entraînement enregistré",
    "dialogTitle": "Enregistrer un entraînement",
    "typeLabel": "Type",
    "nameLabel": "Nom",
    "namePlaceholder": "ex. Course au parc, Push day…",
    "dateLabel": "Date",
    "durationLabel": "Durée (min)",
    "intensityLabel": "Intensité",
    "kcalLabel": "Kcal brûlées",
    "kcalAuto": "auto",
    "kcalHint": "Laisse vide pour une estimation automatique selon le poids et l'intensité.",
    "exercisesLabel": "Exercices",
    "addExercise": "Ajouter un exercice",
    "exercisePh": "ex. Développé couché, Squat…",
    "reps": "rép.",
    "addSet": "Ajouter une série",
    "notesLabel": "Notes",
    "notesPh": "Comment s'est passé l'entraînement ?",
    "save": "Enregistrer",
    "trainingPlanSaved": "Plan d'entraînement enregistré",
    "trainingPlanEmpty": "Pas encore de jours d'entraînement",
    "trainingPlanTag": "Mon plan d'entraînement",
    "trainingPlanQ": "Quels jours t'entraînes-tu d'habitude ?",
    "trainingPlanTypeTitle": "Type d'entraînement par jour",
    "trainingPlanHint": "Les jours non sélectionnés ne comptent pas automatiquement comme jours de repos.",
    "trainingPlanApply": "Appliquer",
    "workoutsShort": "séances",
    "calLegendDone": "Entraînement",
    "calLegendToday": "Aujourd'hui",
    "calLegendSelected": "Sélectionné",
    "calLegendPlanned": "Prévu",
    "calLegendRecovery": "Récupération",
    "calLegendSkip": "Jour de repos",
    "confirmDelete": "Supprimer cet entraînement ?",
    "deleted": "Entraînement supprimé",
    "markSkipOk": "Noté — pas d'entraînement aujourd'hui",
    "markSkipError": "Enregistrement impossible, réessayer ?",
    "unskipOk": "Jour de repos supprimé",
    "title": "Entraînements",
    "subtitle": "Suis cardio, muscu et stretching",
    "newBtn": "Nouvel entraînement",
    "weekCount": "Séances 7 j",
    "weekMin": "Minutes 7 j",
    "weekKcal": "Kcal 7 j",
    "skipNudgeTag": "Ça arrive",
    "skipNudgeTitle": "{n} jours de repos d'affilée — on réorganise ?",
    "skipNudgeBody": "Pas de stress. Choisis d'autres jours d'entraînement qui collent mieux à ta semaine. On s'adapte.",
    "skipNudgeCta": "Réorganiser ma semaine",
    "skipNudgeLater": "Plus tard",
    "emptyState": "Pas encore d'entraînement. Enregistre le premier !",
    "recoveryDoneTitle": "La récupération fait partie du progrès",
    "recoveryQuote": "La récupération fait partie du progrès. Ton corps devient plus fort pendant les pauses.",
    "recoveryStreakStrip": "Série de récupération : {n} semaine",
    "recoveryNextBadge": "Niveau suivant",
    "recoveryWeeksUnit": "semaines",
    "workout": "entraînement",
    "dayIsRestDay": "Jour de repos",
    "dayIsPlanned": "Entraînement prévu aujourd'hui",
    "dayIsPlannedFuture": "Jour d'entraînement prévu",
    "dayIsFuture": "Jour à venir",
    "dayIsFree": "Jour libre",
    "reasonRestDay": "Jour de repos",
    "reasonSick": "Malade",
    "reasonNoTime": "Pas le temps",
    "reasonPain": "Douleur",
    "reasonOther": "Autre",
    "dayIsRecovery": "Repos volontaire",
    "skipNoReason": "Sans raison",
    "unskipCta": "Finalement entraîné ?",
    "changeReasonCta": "Changer la raison",
    "pickReasonTitle": "Que se passe-t-il aujourd'hui ?",
    "skipNoReasonCta": "Enregistrer sans raison",
    "planTrainingCta": "Planifier l'entraînement",
    "markDone": "Je me suis entraîné",
    "markSkip": "Pas d'entraînement",
    "markRestDay": "Jour de repos",
    "addAnotherCta": "Ajouter un autre entraînement",
    "totalSets": "Séries totales",
    "totalVolume": "Volume total",
    "noExtraDetails": "Pas de détails supplémentaires.",
    "todayCount": "aujourd'hui",
    "kcalBudgetOn": "Kcal d'entraînement incluses dans le budget",
    "kcalBudgetOff": "Kcal d'entraînement hors budget",
    "kcalBudgetShort": "Budget kcal avec entraînement"
  },
  "weekly": {
    "mealLoading": "Préparation de la recette complète…",
    "fiber": "Fibres",
    "ingredients": "Ingrédients",
    "procedure": "Préparation",
    "servings": "Port.",
    "voiceNoMatch": "Aucune correspondance",
    "voiceUnsupported": "Ton navigateur ne prend pas en charge la reconnaissance vocale",
    "voiceError": "Erreur de micro",
    "focusMode": "Mode courses",
    "showDone": "Afficher les achetés",
    "hideDone": "Masquer les achetés",
    "allBought": "Tout est acheté !",
    "voiceListening": "J'écoute…",
    "voiceStop": "Arrêter l'écoute",
    "voiceStart": "Cocher à la voix",
    "title": "Menu hebdomadaire",
    "movedToPantry": "Déplacé au garde-manger",
    "expiry": {
      "title": "{name} acheté",
      "body": "À consommer avant ? Facultatif – garde le score de fraîcheur à jour.",
      "d3": "+3 jours",
      "w1": "+1 semaine",
      "w2": "+2 semaines",
      "m1": "+1 mois",
      "until": "À consommer avant le {date}",
      "skip": "Sans date",
      "save": "Au garde-manger"
    },
    "shoppingList": "Liste de courses",
    "emptyHint": "Tu n'as pas encore de menu. Touche « Générer le menu » pour en créer un adapté à toi.",
    "copied": "Liste de courses copiée dans le presse-papiers",
    "generatedWithList": "Menu prêt ! Les ingrédients manquants ont été ajoutés à ta liste de courses.",
    "subtitle": "7 jours équilibrés selon tes objectifs",
    "regenerate": "Régénérer",
    "generate": "Générer le menu",
    "printMenu": "Imprimer le menu",
    "printMenuShort": "Menu",
    "generatedAt": "Généré",
    "print": "Imprimer",
    "share": "Partager",
    "focusModeShort": "Courses",
    "viewShoppingList": "Voir la liste",
    "autoSyncedHint": "Les ingrédients absents de ton garde-manger ont été ajoutés automatiquement à ta liste de courses."
  },
  "pantryFeed": {
    "action": {
      "add": "a ajouté",
      "update": "a mis à jour",
      "delete": "a retiré",
      "deduct": "a utilisé",
      "used_up": "a épuisé",
      "consumed": "a marqué comme terminé",
      "restored": "a restauré",
      "undo": "a annulé l'utilisation de"
    },
    "title": "Activité récente"
  },
  "exlib": {
    "ctaBtn": "Composer un entraînement",
    "ctaHint": "Choisis des exercices, charge un modèle ou entraîne-toi en direct",
    "title": "Bibliothèque d'exercices",
    "subtitle": "Plus de 870 exercices avec images – force, cardio, étirements",
    "tabSearch": "Exercices",
    "tabTemplates": "Modèles",
    "tabPlan": "Mon plan",
    "searchPlaceholder": "Chercher un exercice ou un muscle…",
    "all": "Tous",
    "results": "{n} exercices",
    "exercises": "exercices",
    "loadingInstructions": "Traduction des consignes…",
    "addToPlan": "Ajouter à l'entraînement",
    "inPlan": "Dans le plan",
    "planEmpty": "Pas encore d'exercices – choisis-en ou charge un modèle.",
    "sets": "Séries",
    "reps": "Rép.",
    "repsShort": "rép.",
    "seconds": "Sec",
    "useTime": "Au temps",
    "useReps": "Aux rép.",
    "saveDone": "Enregistrer comme fait",
    "startLive": "Commencer",
    "customWorkout": "Mon entraînement",
    "setsDone": "{done} sur {total} séries",
    "rest": "Repos",
    "finish": "Terminer",
    "abortConfirm": "Abandonner ? Les séries cochées seront perdues.",
    "saved": "Entraînement enregistré – {min} min, bravo !",
    "liveNote": "Entraînement en direct : {done}/{total} séries",
    "savedPlan": "Entraînement enregistré",
    "lastTime": "Dernière fois : {w} kg × {r} ({d})",
    "lastTimeReps": "Dernière fois : {r} rép. ({d})",
    "best": "Record {w} kg",
    "newRecord": "Nouveau record !",
    "saveTemplate": "Enregistrer comme modèle",
    "templateName": "Nom du modèle",
    "templateSaved": "Modèle enregistré",
    "myTemplates": "Mes modèles",
    "fromCoach": "Du coach",
    "deleteTemplateConfirm": "Supprimer ce plan ?",
    "myPlansTitle": "Mes plans d'entraînement",
    "myPlansHint": "Appuyer pour démarrer directement",
    "assignToClient": "Attribuer au client",
    "assigned": "Plan attribué",
    "coachPlansTitle": "Plans d'entraînement",
    "coachPlansEmpty": "Aucun plan attribué – composez-en un depuis la bibliothèque d'exercices.",
    "assignBtn": "Attribuer un plan",
    "editPlan": "Modifier le plan",
    "saveChanges": "Enregistrer les modifications",
    "changesSaved": "Plan mis à jour",
    "daysLabel": "Jours",
    "todayDue": "Aujourd'hui",
    "todaySuggest": "Au programme aujourd'hui : {name}",
    "historyTitle": "Entraînements live & records",
    "historyEmpty": "Aucun entraînement avec exercices enregistré.",
    "curveTitle": "Charge max – {weeks} dernières semaines",
    "curveEmpty": "Pas encore assez de données – à partir de la 2e séance avec charge.",
    "suggestWeight": "Toutes les séries réussies la dernière fois – suggestion {w} kg (+2,5)",
    "keepLast": "Garder {w} kg",
    "weekTitle": "Ton bilan de la semaine",
    "weekWorkouts": "Séances",
    "weekMinutes": "Minutes",
    "weekVolume": "Volume",
    "weekRecords": "Records",
    "weekVolumeHint": "Tu as soulevé {kg} kg cette semaine – séries × rép. × charge. Bravo !",
    "weekHint": "Note tes charges à la prochaine séance pour voir ton volume ici.",
    "weekShare": "Partager le bilan",
    "weekNewRecords": "Nouveaux records",
    "weekShareNoRecords": "Continue – un record tombera la semaine prochaine !",
    "weekShareFooter": "Entraîné avec Solano Essence",
    "weekShareDownloaded": "Image enregistrée",
    "deloadHint": "{n} semaines de progression d'affilée – plus léger cette semaine : {w} kg (−10 %)",
    "deloadApply": "Appliquer",
    "deloadTitle": "Semaine de décharge conseillée",
    "deloadBody": "{names} : {n} semaines de hausse d'affilée. Entraîne-toi à −10 % cette semaine – ton corps récupère et tu reviens plus fort·e.",
    "swapTitle": "Machine occupée ? Alternative même muscle",
    "swapEmpty": "Aucune alternative adaptée.",
    "swapped": "Remplacé par {name}",
    "photoStart": "Départ",
    "photoEnd": "Arrivée",
    "openDetail": "Voir l'exercice",
    "placeGym": "Salle",
    "placeHome": "Maison",
    "showAll": "Tout afficher",
    "showCore": "Classiques seulement",
    "pickGroup": "Que veux-tu travailler ?",
    "coreCount": "{n} classiques",
    "resultsCore": "{n} classiques · {all} au total",
    "moreAll": "Afficher {n} exercices de plus",
    "empty": "Rien trouvé – essaie un autre terme.",
    "coreBadge": "Classique",
    "guideLoading": "Chargement des conseils…",
    "steps": "Exécution",
    "tips": "Conseils technique",
    "mistakes": "Erreurs fréquentes",
    "breathing": "Respiration",
    "feel": "Où tu le sens",
    "easier": "Plus facile",
    "harder": "Plus difficile",
    "showPhotos": "Afficher les photos originales",
    "hidePhotos": "Masquer les photos",
    "regenImage": "Pose incorrecte ? Redessiner",
    "regenDone": "Mascotte redessinée",
    "regenRecent": "Déjà redessinée ces dernières 24 h",
    "regenBudget": "Budget IA du jour épuisé – réessaie plus tard",
    "group": {
      "chest": "Pectoraux",
      "back": "Dos",
      "legs": "Jambes & fessiers",
      "shoulders": "Épaules",
      "arms": "Bras",
      "core": "Abdos & gainage",
      "cardio": "Cardio & corps entier",
      "stretch": "Mobilité & étirements"
    }
  },
  "recipePhoto": {
    "title": "Changer l'image de la recette",
    "menu": "Changer la photo",
    "takePhoto": "Prendre une photo",
    "fromGallery": "Choisir dans la galerie",
    "aiHint": "L'IA crée une photo culinaire adaptée à partir du nom et des ingrédients",
    "remove": "Supprimer la photo",
    "updated": "Image de la recette mise à jour",
    "removed": "Image de la recette supprimée",
    "cropTitle": "Recadrer l'image",
    "cropHint": "Glisse pour déplacer, pince pour zoomer, flèches pour pivoter",
    "cropApply": "Recadrer et enregistrer",
    "styleTitle": "Style de la photo IA",
    "styleRustic": "Rustique",
    "styleBright": "Clair et moderne",
    "styleTopdown": "Vue du dessus",
    "generateNow": "Générer maintenant",
    "variantsBtn": "Générer 2 propositions",
    "variantsGenerating": "Deux propositions en cours…",
    "pickTitle": "Laquelle préfères-tu ?",
    "pickHint": "Touche la meilleure photo et applique-la.",
    "variantsRetry": "Réessayer",
    "variantApply": "Utiliser celle-ci"
  },
  "recipeScan": {
    "addPage": "Ajouter une page / le verso",
    "photosCount": "{n} photo(s) sélectionnée(s)",
    "readBtn": "Lire la recette",
    "removePhoto": "Retirer la photo",
    "or": "ou",
    "urlLabel": "Coller un lien de recette",
    "urlPlaceholder": "https://…/recette",
    "urlBtn": "Importer",
    "urlReading": "Lecture de la page…",
    "urlError": "Impossible de charger la page – vérifie le lien ou photographie une capture.",
    "invalidUrl": "Saisis un lien valide.",
    "ctaBtn": "Photographier une recette",
    "title": "Recette depuis une photo",
    "subtitle": "Photographie une page de livre de cuisine ou une fiche recette – l'IA la transforme en recette Solano.",
    "takePhoto": "Prendre une photo",
    "fromGallery": "Depuis la galerie",
    "tip": "Astuce : page bien à plat et éclairée ; ingrédients et étapes doivent être lisibles.",
    "scanning": "Lecture de la recette…",
    "scanningHint": "Détection des ingrédients, quantités et étapes, puis calcul des valeurs nutritionnelles.",
    "reviewTitle": "Vérifier la recette",
    "reviewDesc": "Vérifie le nom, les quantités et les étapes – puis enregistre.",
    "nameLabel": "Nom",
    "servingsLabel": "Portions",
    "ingredientsLabel": "Ingrédients (un par ligne)",
    "stepsLabel": "Préparation (une étape par ligne)",
    "filledNote": "{n} ingrédient(s) sans quantité ont été complétés avec des quantités typiques – à vérifier.",
    "usePhoto": "Utiliser la photo comme image de la recette",
    "fromSource": "Source : {title}",
    "lowConfidence": "La page était difficile à lire – vérifie bien les ingrédients et quantités.",
    "save": "Enregistrer comme recette",
    "saved": "Recette « {name} » enregistrée",
    "retake": "Autre photo",
    "noRecipe": "Aucune recette détectée sur la photo – photographie une page avec ingrédients et préparation.",
    "error": "Impossible de lire la recette – réessaie."
  },
  "fridge": {
    "photoDetected": "{count} ingrédients ajoutés depuis la photo",
    "photoRecogError": "Ingrédients non reconnus, réessaie",
    "needIngredients": "Ajoute au moins 2 ingrédients.",
    "errorGen": "Erreur de génération. Réessaie.",
    "photoDone": "Photo prête !",
    "photoError": "Erreur photo IA.",
    "recipeReady": "Recette prête !",
    "title": "Qu'y a-t-il dans ton frigo ?",
    "reviewDesc": "Enregistrée dans ton livre de recettes. Tu peux générer une photo IA.",
    "subtitle": "Liste les ingrédients que tu as et l'IA crée une recette complète avec macros et nutriments.",
    "ingredientsLabel": "Tes ingrédients",
    "ingredientsPlaceholder": "ex. 2 œufs, 200 g de tomates, mozzarella, riz, basilic, huile d'olive",
    "ingredientsHint": "Sépare par des virgules. Sel, poivre, eau et huile sont considérés comme disponibles.",
    "recognizing": "Analyse…",
    "photoBtn": "Photo du frigo",
    "mealTypeLabel": "Type de repas (optionnel)",
    "maxTimeLabel": "Temps max (min)",
    "servingsLabel": "Portions",
    "goalLabel": "Pour quel objectif ?",
    "dietaryLabel": "Préférences (optionnel)",
    "generateBtn": "Générer la recette",
    "generating": "Je réfléchis à ta recette…",
    "generatingHint": "GPT-5.2 planifie les ingrédients, les étapes et les macros.",
    "servingsShort": "port.",
    "matchedTip": "Calculé à partir de la base de données Solano.",
    "macrosAccurate": "Macros précises",
    "ingredientsSection": "Ingrédients",
    "stepsSection": "Étapes",
    "missingLabel": "Ingrédients optionnels qui amélioreraient la recette :",
    "newRecipe": "Nouvelle",
    "generatePhoto": "Générer une photo IA",
    "done": "Terminé",
    "ctaBtn": "Cuisiner avec le frigo",
    "goalHint": {
      "weight_loss": "≈ 350–500 kcal · ≥ 20 g de protéines par portion",
      "maintenance": "≈ 450–650 kcal · macros équilibrés",
      "muscle_gain": "≈ 600–800 kcal · ≥ 35 g de protéines par portion"
    }
  },
  "betaInvites": {
    "created": "Code créé",
    "shareText": "Salut {name} ! Voici ton invitation pour Solano Essence :",
    "defaultName": "client",
    "linkCopied": "Lien copié",
    "waTemplate": "Salut {name} ! 👋\n\nBienvenue sur Solano Essence — ton app de nutrition personnalisée.\n\nInscris-toi ici avec ton code d'invitation :\n{url}\n\nSi l'inscription demande le code manuellement, utilise celui du lien.\n\nÀ bientôt ! 🥗",
    "title": "Invitations bêta",
    "subtitle": "Codes à usage unique pour inviter tes clients",
    "active": "actifs",
    "newInvite": "Nouvelle invitation",
    "labelPh": "Nom du client (optionnel)",
    "emailPh": "E-mail du client (optionnel)",
    "generate": "Générer",
    "emailHint": "Ajoute l'e-mail pour garantir que seul ce client puisse utiliser le code.",
    "empty": "Aucune invitation. Génère la première ci-dessus.",
    "usedBy": "utilisé par",
    "sendWhatsApp": "Envoyer via WhatsApp",
    "showQr": "Afficher le code QR",
    "copyCode": "Copier le code",
    "shareLink": "Partager le lien",
    "revoke": "Révoquer",
    "qrTag": "Code QR",
    "qrTitle": "Inviter un client",
    "qrHint": "Fais scanner ce code à ton client pour ouvrir la page d'inscription avec le code prérempli.",
    "status": {
      "active": "Actif",
      "used": "Utilisé",
      "revoked": "Révoqué"
    }
  },
  "cook": {
    "addedToList": "{n} ajoutés à la liste",
    "missing": "{n} manquants",
    "addMissing": "Ajouter à la liste",
    "cook": "Cuisiner",
    "title": "Qu'est-ce que je cuisine ?",
    "subtitle": "{n} idées avec ton garde-manger",
    "haveAll": "Tout est disponible",
    "oneMissing": "1 ingrédient manquant",
    "manyMissing": "Plusieurs ingrédients manquants"
  },
  "progressPhotos": {
    "saved": "Photo enregistrée",
    "title": "Photos de progrès",
    "subtitle": "Face, profil, dos — compare dans le temps",
    "compare": "Comparer",
    "front": "Face",
    "side": "Profil",
    "back": "Dos",
    "photoBtn": "Photo",
    "empty": "Pas encore de photos.",
    "emptyHint": "Touche pour ajouter ta première photo",
    "latest": "Dernières photos",
    "timeline": "Chronologie",
    "openCompare": "Comparer la sélection",
    "compareTitle": "Comparaison"
  },
  "theme": {
    "light": "Clair",
    "dark": "Sombre",
    "system": "Système",
    "title": "Apparence",
    "systemHint": "Suit les réglages de l'appareil"
  },
  "admin": {
    "illu_title": "Images mascotte entraînement",
    "illu_exercises": "exercices",
    "illu_today": "Cette nuit",
    "illu_last_night": "Nuit dernière",
    "illu_eta": "Durée restante",
    "illu_nights": "{n} nuits",
    "illu_window": "Tourne la nuit {w}",
    "illu_running": "en cours",
    "illu_next": "prochain passage {at}",
    "illu_remaining": "{n} exercices restants",
    "subKind": "Subscription type",
    "subSince": "Since",
    "segNew": "New (7 days)",
    "segInactive": "Inactive (7 days+)",
    "segPaid": "Pro paid",
    "segComp": "Pro gifted",
    "testAccount": "Test account",
    "testMark": "Mark as test account (excluded from stats)",
    "testUnmark": "Remove mark",
    "testMarked": "Marked as test account — excluded from numbers",
    "testUnmarked": "Test mark removed",
    "adherence": "Adherence",
    "untilShort": "until",
    "expiredShort": "expired",
    "activeUsersLegend": "Active users",
    "aiCostMonth": "AI cost this month",
    "aiShareNet": "Share of net revenue",
    "aiUsageEstNote": "Costs = estimates per call type",
    "aiLimitsTitle": "Pro limits per month",
    "countsNote": "Counts exclude test and team accounts — same everywhere.",
    "revenueEstimate": "Estimate from active subscriptions × price",
    "filterAll": "All",
    "onlyPublic": "Public only",
    "onlyPrivate": "Private only",
    "onlyDupes": "Duplicates",
    "publicLabel": "Public",
    "privateLabel": "Private",
    "merge": "Merge",
    "mergeTitle": "Merge duplicate recipes",
    "mergeHint": "Pick the recipe to keep. Favorites and collections of the others are carried over, the duplicates are deleted.",
    "mergeKeep": "Merge",
    "mergeDone": "{n} duplicate(s) merged",
    "ingredientsShort": "ingredients",
    "recipeDeleteTitle": "Really delete this recipe?",
    "recipeDeleteBody": "This cannot be undone.",
    "foodDeleteTitle": "Really delete this food?",
    "editFood": "Edit food",
    "foodName": "Name",
    "per100g": "Nutrition per 100 g",
    "fiberShort": "Fiber",
    "markVerified": "Mark as verified",
    "verified": "verified",
    "settings": "Settings",
    "appleFee": "Apple fee (%)",
    "usdChf": "USD → CHF rate",
    "settingsHint": "Default 15% (Small Business Program). The rate converts AI costs to CHF.",
    "gross": "Gross",
    "net": "Net",
    "expiresOn": "expires on",
    "expiredOn": "expired on",
    "daysShort": "days",
    "noExpiry": "no expiry",
    "inviteUpgrade": "Invite",
    "inviteSent": "Pro upgrade invitation sent",
    "manualSet": "Manual",
    "sourcesHint": "Apple ✓ = paid via Apple and confirmed by receipt. Manual = Pro set without a payment source.",
    "expiringSoon": "Expiring in the next 14 days",
    "expiringNone": "No gifted Pro expires in the next 14 days.",
    "paidSubs": "Paid subscriptions",
    "unverifiedSubs": "Unconfirmed / manual",
    "unverifiedHint": "These Pro accesses are not backed by an Apple receipt.",
    "giftedSubs": "Gifted Pro accesses",
    "sortedByExpiry": "sorted by expiry",
    "revenueTitle": "Revenue / month",
    "revenueNoPrices": "Apple prices not configured (APPLE_PRICE_MONTHLY/_YEARLY)",
    "revenueMonthly": "monthly",
    "revenueYearly": "yearly",
    "revMonthlySubs": "Monthly plans",
    "revYearlySubs": "Yearly plans",
    "revPerMonth": "per month",
    "revPerYear": "per year (one-off)",
    "navAdmin": "Admin",
    "tab_overview": "Aperçu",
    "tab_users": "Utilisateurs",
    "tab_moderation": "Modération",
    "tab_subs": "Abonnements",
    "mrr": "Revenus/mois",
    "logoutConfirmTitle": "Se déconnecter ?",
    "logoutConfirmBody": "Tu devras te reconnecter ensuite.",
    "subsApple": "Apple",
    "subsWeb": "Web",
    "subsComp": "Offert",
    "recentUsers": "Nouveaux utilisateurs",
    "seeAllUsers": "Tous les utilisateurs",
    "todayImportant": "Important aujourd'hui",
    "todayImportantEmpty": "Tout est au vert. Rien à faire.",
    "grpInactive": "{n} utilisateurs inactifs depuis 7+ jours",
    "grpFading": "{n} utilisateurs avec une activité en baisse",
    "grpOverKcal": "{n} utilisateurs au-dessus de l'objectif calorique",
    "grpLowProtein": "{n} utilisateurs sous l'objectif protéines",
    "grpNewLogs": "{n} nouvelles entrées de journal aujourd'hui",
    "foodEntries": "Entrées alimentaires",
    "viewTracking": "Voir le suivi et les détails",
    "resetApple": "Réinitialiser l'abonnement Apple",
    "resetAppleConfirm": "Retirer l'abonnement Apple de la base de données ? (Tests sandbox uniquement — un vrai abonnement actif se réactive)",
    "resetAppleOk": "Abonnement Apple réinitialisé",
    "title": "Espace admin",
    "subtitle": "Gestion de l'app — super admin uniquement",
    "statUsers": "Utilisateurs",
    "statActive7d": "actifs (7 j)",
    "statPendingOnboarding": "sans onboarding",
    "statLogsToday": "Entrées aujourd'hui",
    "todayLogsTitle": "Entrées du jour",
    "openProfile": "Ouvrir le profil",
    "todayLogsEmpty": "Aucune entrée aujourd'hui",
    "activeUsersTitle": "Actifs ces 7 derniers jours",
    "activeUsersEmpty": "Aucun utilisateur actif",
    "lastActive": "dernière activité",
    "logs7d": "entrées (7 j)",
    "justNow": "à l'instant",
    "inactiveChip": "Inactifs 7j+",
    "inactiveTitle": "Utilisateurs inactifs",
    "inactiveHint": "Aucune entrée depuis 7+ jours. Le rappel envoie une notification push 🔔 (si activée) et un e-mail ✉️.",
    "inactiveEmpty": "Tout le monde est actif 🎉",
    "nudge": "Rappeler",
    "nudgeAll": "Rappeler tous",
    "nudgeAllConfirm": "Rappeler {n} utilisateurs (push + e-mail) ?",
    "nudgeAllDone": "{n} utilisateurs rappelés",
    "nudgeSent": "Rappel envoyé",
    "nudgeNoChannel": "aucun canal (ni push ni e-mail)",
    "nudgedOn": "rappelé le",
    "neverLogged": "jamais d'entrée",
    "daysInactive": "jours inactif",
    "statSubs": "Abos",
    "statBlocked": "Bloqués",
    "statReports": "signalements",
    "aiLimitsSaved": "Limites enregistrées",
    "aiUsageTotals": "Toute l'app",
    "aiUsageCalls": "appels",
    "aiUsageEmpty": "Aucun appel IA ce mois-ci.",
    "searchUsers": "Chercher des utilisateurs (nom ou e-mail)…",
    "last7days": "7 derniers jours",
    "allLetters": "Tous",
    "country": "Pays",
    "countryAll": "Tous les pays",
    "countryUnknown": "Inconnu",
    "signupsByCountry": "Inscriptions par pays et semaine",
    "signupsByCountryHint": "8 dernières semaines",
    "countryOther": "Autres",
    "signupsNone": "Pas encore d'inscriptions",
    "proByCountry": "Abonnements Pro par pays",
    "proByCountryHint": "tous les utilisateurs · conversion = Pro payants / utilisateurs",
    "proGifted": "Offerts",
    "proConversion": "Conv.",
    "filterActive": "Actifs",
    "filterBlocked": "Bloqués",
    "grantAllConfirm": "Offrir le Pro gratuit (🎁) à tous les utilisateurs existants sans Pro ?",
    "grantAllOk": "Pro offert à {n} utilisateurs 🎁",
    "grantAllBtn": "Offrir le Pro gratuit à tous les utilisateurs existants (une fois, pour les testeurs)",
    "noUsers": "Aucun utilisateur trouvé.",
    "blocked": "Bloqué",
    "role": "Rôle",
    "registered": "Inscrit",
    "plan": "Plan",
    "compProTitle": "Pro gratuit",
    "compProActive": "Offert — l'utilisateur a le Pro gratuitement",
    "compProPaid": "L'utilisateur a un abonnement payant",
    "compProOff": "Débloquer la version complète gratuitement",
    "compProRevokedOk": "Pro gratuit révoqué",
    "compProRevoke": "Révoquer",
    "compProGrantedOk": "Pro offert 🎁",
    "compProUntil": "Offert jusqu'au",
    "compProGrant3m": "3 mois",
    "compProGrant1m": "1 mois",
    "compProGranted1mOk": "Pro offert pour 1 mois 🎁",
    "compProGrant12m": "1 an",
    "compProGrantUnlimited": "Illimité",
    "compProGranted3mOk": "Pro offert pour 3 mois 🎁",
    "compProGranted12mOk": "Pro offert pour 1 an 🎁",
    "compProGrant": "Offrir le Pro",
    "linkedClients": "Clients liés",
    "weights": "Poids",
    "changeRole": "Rôle",
    "roleChangedOk": "Rôle modifié",
    "payments": "Paiements",
    "blockReasonPrompt": "Raison du blocage (optionnel) :",
    "blockedOk": "Utilisateur bloqué",
    "block": "Bloquer",
    "unblockedOk": "Utilisateur débloqué",
    "unblock": "Débloquer",
    "delete": "Supprimer",
    "deletedOk": "Utilisateur et toutes ses données supprimés",
    "deleteConfirm": "Vraiment supprimer ?",
    "recipes": "Recettes",
    "foods": "Aliments",
    "publishOk": "Recette publiée",
    "unpublishOk": "Recette masquée",
    "recipeDeletedOk": "Recette supprimée",
    "searchRecipes": "Chercher des recettes…",
    "noRecipes": "Aucune recette trouvée.",
    "unpublish": "Masquer",
    "publish": "Publier",
    "foodDeletedOk": "Entrée supprimée",
    "searchFoods": "Chercher des aliments (min. 2 caractères pour la base intégrée)…",
    "foodsLearned": "Aliments appris",
    "foodsCustom": "Aliments personnalisés (utilisateurs)",
    "bp": {
      "tab": "Appris",
      "hint": "Produits appris par les utilisateurs via code-barres (photo du tableau nutritionnel ou saisie manuelle). Les produits vérifiés font foi pour tous les utilisateurs.",
      "search": "Rechercher nom, marque ou code-barres…",
      "toReview": "À vérifier",
      "empty": "Aucun produit appris",
      "global": "Global",
      "fromLabel": "Photo étiquette",
      "verify": "Vérifier",
      "unverify": "Vérifié",
      "verifiedOk": "Produit vérifié – s'applique désormais à tous",
      "unverifiedOk": "Vérification retirée",
      "deletedOk": "Produit supprimé",
      "deleteTitle": "Supprimer le produit ?",
      "deleteBody": "sera supprimé pour tous les utilisateurs. Au prochain scan, il sera à nouveau signalé comme inconnu.",
      "editTitle": "Corriger le produit",
      "brand": "Marque",
      "ingredients": "Ingrédients",
      "markVerified": "Marquer comme vérifié (pour tous les utilisateurs)"
    },
    "foodsBuiltin": "Base intégrée (lecture seule)",
    "dailyActivity": "Activité (14 jours) : entrées et utilisateurs actifs",
    "signups": "Inscriptions par semaine",
    "noSubs": "Pas encore d'abonnés.",
    "gifted": "Offert",
    "recentTx": "Transactions récentes",
    "noReports": "Aucun signalement.",
    "noAudit": "Aucune action admin enregistrée.",
    "aiFeat": {
      "food_photo": "Photo de repas",
      "food_photo_hint": "Ré-analyse (indice)",
      "fridge_photo": "Photo garde-manger",
      "workout_photo": "Import d'entraînement",
      "coach_chat": "Coach IA",
      "pantry_recipe": "Recettes du garde-manger",
      "weekly_menu": "Menus hebdo",
      "social_caption": "Textes sociaux"
    }
  },
  "shopping": {
    "addedToList": "Ajouté à la liste de courses",
    "restocked": "{name} de retour au garde-manger",
    "importedAdded": "{n} nouveaux",
    "importedMerged": "{n} mis à jour",
    "importedRestocked": "{n} réapprovisionnés",
    "importedNothing": "Rien à importer",
    "empty": "La liste est vide",
    "title": "Liste de courses",
    "copied": "Liste copiée dans le presse-papiers",
    "itemsCount": "{n} articles à acheter",
    "shareBtn": "Partager la liste",
    "addPlaceholder": "Ajouter un article (ex. Lait)…",
    "importAll": "Tout déplacer au garde-manger",
    "emptyHint": "Ajoute ce dont tu as besoin, ou attends que des produits s'épuisent.",
    "reason": {
      "expired": "Expiré",
      "consumed": "Épuisé",
      "weeklyMenu": "Du menu hebdo",
      "shoppingCheck": "Du Check courses"
    },
    "restockHint": "Acheter : {qty} · dure ~{days} j",
    "boughtBtn": "Acheté",
    "checkedByScan": "Coché",
    "movedToPantry": "{name} → ajouté au garde-manger",
    "uncheckBtn": "Remettre sur la liste",
    "notNeededBtn": "Pas besoin"
  },
  "profile": {
    "proQuotaLeft": "restantes",
    "notifOk": "Push activé ✓",
    "notifDenied": "Autorisation bloquée : active-la dans les réglages du navigateur.",
    "notifUnsupported": "Push non pris en charge sur cet appareil.",
    "notifTitle": "Notifications push",
    "notifActive": "actives",
    "notifHelper": "Active les rappels pour les repas et l'eau. Tu recevras une notification aux heures définies.",
    "notifEnableCta": "Activer les notifications push sur cet appareil",
    "notifTestSent": "Notification test envoyée ✓",
    "notifTestCta": "Envoyer une notification test",
    "notifResetOk": "Abonnement actualisé ✓",
    "notifResetFail": "Réinitialisation échouée. Retire la PWA de l'écran d'accueil et réinstalle-la.",
    "notifResetCta": "Réinitialiser et se réabonner",
    "notifTz": "Fuseau horaire",
    "notifMeals": "Rappels de repas",
    "notifWater": "Rappels d'eau",
    "notifWaterFrom": "De",
    "notifWaterTo": "À",
    "notifWaterFreq": "Toutes les",
    "notifTraining": "Rappel d'entraînement",
    "notifPlan": "Rappel du plan le matin",
    "notifPlanHint": "Les jours où un plan est prévu : « Aujourd'hui : Jambes – prêt·e ? » – un appui lance la séance.",
    "notifTrainingAt": "À",
    "notifTrainingHint": "Envoyé uniquement les jours d'entraînement prévus — si tu n'as pas déjà enregistré un entraînement ce jour-là.",
    "notifEvening": "Récap du soir",
    "notifEveningAt": "À",
    "notifEveningPreview": "Aperçu",
    "notifEveningSendNow": "Envoyer maintenant",
    "updated": "Profil mis à jour",
    "saveBtn": "Enregistrer le profil",
    "linkNutOk": "Nutritionniste lié !",
    "linkNutBtn": "Lier",
    "title": "Mon profil",
    "subtitle": "Garde tes données à jour pour un plan plus précis.",
    "proActiveHint": "Pro est actif — gérer l'abonnement",
    "proUpsellHint": "Débloque plus de possibilités pour ton quotidien",
    "sectionAccount": "Compte",
    "fullName": "Nom complet",
    "birthdate": "Date de naissance",
    "gender": "Genre",
    "female": "Femme",
    "male": "Homme",
    "other": "Autre",
    "height": "Taille (cm)",
    "startingWeight": "Poids de départ (kg)",
    "kcalTarget": "Objectif kcal",
    "goal": "Objectif",
    "weightLoss": "Perte de poids",
    "maintenance": "Maintien",
    "muscle": "Prise de muscle",
    "performance": "Performance sportive",
    "activity": "Niveau d'activité",
    "sedentary": "Sédentaire",
    "light": "Léger",
    "moderate": "Modéré",
    "intense": "Intense",
    "athlete": "Athlète",
    "sport": "Sport pratiqué",
    "sportPh": "ex. course, football, muscu...",
    "allergies": "Allergies / intolérances",
    "medical": "Notes médicales",
    "personalDataTitle": "Données personnelles",
    "languageTitle": "Langue",
    "languageHint": "Langue de l'app — indépendante des réglages de l'appareil",
    "notifTapToOpen": "Touche pour gérer les rappels",
    "sectionSettings": "Réglages",
    "sectionConnections": "Connexions",
    "devicesTapToOpen": "Touche pour connecter des appareils",
    "widgetSyncOk": "Widget mis à jour ✓ {kcal} kcal · {water} · {steps} pas",
    "widgetSyncFail": "Synchro du widget échouée",
    "widgetSyncTitle": "Actualiser le widget maintenant",
    "widgetSyncHelp": "Pousse les valeurs du jour vers les widgets de l'écran d'accueil"
  },
  "nutAdvice": {
    "title": "Coach nutrition",
    "subtitle": "{count} conseils concrets pour le reste de la journée"
  },
  "household": {
    "defaultName": "Notre foyer",
    "created": "Groupe créé — partage le code d'invitation",
    "joined": "Tu as rejoint le groupe",
    "invalidCode": "Code d'invitation invalide",
    "left": "Tu as quitté le groupe",
    "emptyTitle": "Vous êtes une famille ?",
    "emptyHint": "Partage le garde-manger avec ceux qui font les courses avec toi. Crée un groupe ou rejoins-en un avec un code.",
    "createBtn": "Créer un groupe",
    "joinBtn": "Rejoindre",
    "codePlaceholder": "AB3D4E",
    "sharedPantry": "Garde-manger partagé",
    "inviteCode": "Code d'invitation :",
    "leaveBtn": "Quitter le groupe",
    "leaveConfirmTitle": "Quitter le groupe ?",
    "leaveConfirmText": "Les articles partagés restent dans le groupe. Si tu es le dernier membre, le groupe est dissous et le garde-manger redevient personnel.",
    "leaveConfirmBtn": "Quitter"
  },
  "igImport": {
    "errImageOnly": "Tu ne peux importer que des images",
    "errTooBig": "Image trop lourde, essaie plus petit",
    "errNeedInput": "Colle le texte OU importe une photo de recette",
    "errAnalyze": "Analyse échouée. Réessaie.",
    "saved": "Recette importée et publiée",
    "title": "Importer depuis Instagram",
    "subtitle": "Colle la légende d'un de tes posts — l'IA crée la recette avec les macros USDA/CREA.",
    "urlLabel": "Lien du post (optionnel)",
    "urlHint": "Utile pour retrouver la source plus tard.",
    "captionLabel": "Légende du post",
    "captionPh": "Colle ici la légende Instagram (émojis et hashtags inclus)…",
    "captionHint": "Optionnel si tu importes une photo (ex. infographie de recette) – l'IA lit la recette directement sur l'image.",
    "photoLabel": "Photo du plat (optionnel)",
    "photoPick": "Glisse ou touche pour choisir une photo",
    "photoOptional": "Recommandé : aide l'IA à comprendre le plat",
    "cancel": "Annuler",
    "analyzeBtn": "Analyser avec l'IA",
    "analyzing": "L'IA lit ta recette…",
    "analyzingHint": "Nous extrayons nom, ingrédients, préparation et recalculons les macros depuis la base Solano.",
    "back": "Modifier le texte",
    "fName": "Nom de la recette",
    "fMealType": "Type de repas",
    "fServings": "Portions",
    "fDesc": "Description",
    "fIngredients": "Ingrédients",
    "ingHint": "Un par ligne, avec quantité et unité (ex. 80 g pâtes, 1 œuf)",
    "fInstructions": "Instructions",
    "macrosPreview": "Macros par portion",
    "macrosComputed": "Calculées depuis la base d'aliments",
    "perServing": "portion",
    "saveBtn": "Enregistrer la recette (publique)"
  },
  "providerPrefs": {
    "resetConfirm": "Effacer les données wearable des 7 derniers jours ? La prochaine synchro les récupérera depuis les appareils connectés.",
    "resetDone": "{n} jours effacés. Touche Synchroniser pour actualiser.",
    "saved": "Préférences enregistrées",
    "title": "Préférences de données",
    "subtitle": "Choisis quel appareil utiliser pour chaque mesure",
    "noDevices": "Connecte d'abord un appareil pour définir les préférences",
    "auto": "Auto (max)",
    "resetBtn": "Réinitialiser les données"
  },
  "workoutPhoto": {
    "notRecognized": "Aucune photo ne ressemble à un résumé d'entraînement.",
    "savedToast": "Entraînement enregistré depuis la photo",
    "batchSavedToast": "{n} entraînements enregistrés depuis les photos",
    "batchFailedToast": "{n} entraînements n'ont pas pu être enregistrés",
    "title": "Ajouter depuis une photo",
    "subtitle": "Prends ou importe une capture de résumé d'entraînement (Speediance, Apple Fitness, Garmin…). L'IA extrait durée, kcal et type.",
    "pickPhoto": "Prendre ou choisir une photo",
    "hint": "Les écrans de fin d'entraînement fonctionnent le mieux",
    "batchHint": "Choisis plusieurs photos à la fois (jusqu'à une semaine complète)",
    "analyzingBatch": "Analyse {done}/{total}…",
    "analyzing": "Analyse…",
    "extractedBatch": "{ok} entraînements reconnus · {err} non reconnus",
    "retake": "Reprendre",
    "save": "Enregistrer l'entraînement",
    "saveAll": "Tout enregistrer ({n})",
    "itemNotRecognized": "Non reconnu",
    "durationShort": "min",
    "date": "Date",
    "dateAutoTooltip": "Date détectée automatiquement depuis l'image",
    "openBtn": "Depuis une photo"
  },
  "engagement": {
    "filterAll": "Tous",
    "filterRed": "Inactifs",
    "filterAmber": "En baisse",
    "filterGreen": "Actifs",
    "title": "Engagement des clients",
    "emptyFilter": "Aucun client dans cette catégorie",
    "statusActive": "Actif",
    "statusFading": "En baisse",
    "statusInactive": "Inactif",
    "never": "Jamais actif",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "daysAgo": "jours",
    "lastActive": "Dernière activité"
  },
  "wearables": {
    "empty": "Pas encore de données wearable. Connecte un appareil pour voir Récupération, VFC, Sommeil et plus.",
    "sleep": "Sommeil",
    "hrv": "VFC",
    "restingHr": "FC repos",
    "strain": "Effort",
    "sleepChart": "Sommeil (heures/nuit)",
    "hrvChart": "VFC (ms)",
    "providerConnected": "{p} connecté",
    "deviceConnectedToast": "Appareil connecté",
    "syncOk": "{n} jours mis à jour",
    "syncEmpty": "Pas de nouvelles données",
    "autoSyncFailed": "Synchro auto de {p} échouée",
    "title": "Wearable & Santé",
    "connectDevice": "Connecter un appareil",
    "devicesConnected": "{n} appareils connectés",
    "deviceConnected": "{n} appareil connecté",
    "tapToConnect": "Touche Ajouter pour connecter un wearable et synchroniser sommeil, VFC et activité",
    "sdkError": "SDK non chargé — ouverture dans une nouvelle page",
    "connectBtn": "Connecter",
    "addBtn": "Ajouter",
    "autoSyncing": "Synchro auto…",
    "noDataYet": "Pas encore de données",
    "lastSync": "Dernière synchro :",
    "neverSynced": "Jamais synchronisé",
    "syncing": "Synchro…",
    "syncNow": "Synchroniser"
  },
  "quickSteps": {
    "invalid": "Nombre invalide",
    "saved": "Pas enregistrés",
    "title": "Pas aujourd'hui",
    "subtitle": "Saisis le nombre depuis ton app de podomètre"
  },
  "nutJournal": {
    "replySent": "Réponse envoyée",
    "title": "Journal du client",
    "lastNDays": "Derniers {n} jours",
    "empty": "Le client n'a pas encore écrit de notes de journal.",
    "noContent": "Pas de note — réponses uniquement.",
    "replyPlaceholder": "Écris une réponse au client…"
  },
  "streaks": {
    "diary": "Journal",
    "weight": "Poids",
    "water": "Eau",
    "title": "Série",
    "daysShort": "j",
    "memberSince": "Membre depuis",
    "activeDays": "jours actifs",
    "badgeUnlockOne": "Dans 1 jour tu débloques le badge {name}",
    "badgeUnlockMany": "Dans {n} jours tu débloques le badge {name}",
    "keepItUp": "Continue comme ça !"
  },
  "clientsList": {
    "filterAll": "Tous",
    "filterAction": "Action requise",
    "filterNew": "Nouveaux",
    "title": "Clients",
    "subtitle": "Gère tes clients et leurs plans.",
    "searchPh": "Chercher un client…",
    "empty": "Aucun client",
    "noGoal": "Aucun objectif défini",
    "adherence": "Adhérence",
    "statusGreen": "Sur la bonne voie",
    "statusAmber": "À surveiller",
    "statusRed": "Action requise"
  },
  "nutDash": {
    "alertNeverActive": "Jamais actif",
    "alertInactiveSince": "Depuis",
    "alertDays": "jours d'inactivité",
    "alertOpen": "Ouvrir",
    "alertFading": "Activité en baisse",
    "alertNewLogs": "Nouvelles entrées de journal",
    "alertLogOne": "entrée aujourd'hui",
    "alertLogMany": "entrées aujourd'hui",
    "alertOpenFeed": "Voir le fil",
    "alertDaysShort": "jours",
    "alertKcalOverfix": "(objectif dépassé)",
    "alertProteinTarget": "objectif protéines",
    "hello": "Salut,",
    "subtitleToday": "Voici ton aperçu du jour.",
    "subtitle": "Voici un aperçu de ton cabinet.",
    "appStatsTag": "Propriétaire",
    "appStatsTitle": "Statistiques de l'app",
    "appStatsSub": "Toute l'activité de l'app en un coup d'œil",
    "recentClients": "Clients récents",
    "seeAll": "Tout voir",
    "noClients": "Pas encore de clients",
    "goalToDefine": "objectif non défini",
    "open": "Ouvrir",
    "todayImportant": "Important aujourd'hui",
    "todayImportantEmpty": "Tout est vert. Rien à faire pour l'instant.",
    "thresholdsTag": "Réglages",
    "thresholdsTitle": "Ajuster les seuils d'alerte",
    "thresholdsKcalOver": "Alerte quand kcal au-dessus de l'objectif",
    "thresholdsKcalOverHint": "Notifier quand le client dépasse l'objectif kcal pendant au moins N jours",
    "thresholdsProteinLow": "Alerte quand protéines sous l'objectif",
    "thresholdsProteinLowHint": "Notifier quand le client reste sous l'objectif protéines pendant au moins N jours",
    "thresholdsSave": "Enregistrer",
    "thresholdsDays": "Jours",
    "thresholdsThreshold": "% seuil",
    "copied": "Copié !",
    "copyCode": "Copier le code"
  },
  "feed": {
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "title": "Fil des clients",
    "subtitle": "Toutes les activités de tes clients par ordre chronologique. Touche une carte pour ouvrir le client.",
    "viewChrono": "Chronologique",
    "viewByClient": "Par client",
    "emptyTitle": "Aucune activité récente",
    "emptyDesc": "Les photos de repas, poids, mesures et messages de tes clients apparaîtront ici.",
    "oneActivity": "activité",
    "manyActivities": "activités",
    "commentSent": "Retour envoyé au client",
    "itemOne": "élément",
    "itemMany": "éléments",
    "commentPlaceholder": "Écris un retour rapide…",
    "commentedLabel": "Commenté",
    "commentLabel": "Commenter",
    "weightLogged": "Poids enregistré",
    "measurementUpdated": "Mesures mises à jour",
    "progressPhoto": "Photo de progrès",
    "chatMessage": "Nouveau message"
  },
  "appStats": {
    "title": "Statistiques de l'app",
    "subtitle": "Aperçu de ton cabinet",
    "scopeNote": "Ces chiffres couvrent UNIQUEMENT tes clients et ton cabinet.",
    "orphanNote": "Remarque : {n} comptes clients non liés existent dans le système (tests / invitations ouvertes).",
    "users": "Utilisateurs",
    "myClients": "Mes clients",
    "thisWeek": "cette semaine",
    "coaches": "Coachs au studio",
    "activeToday": "Actifs aujourd'hui",
    "pastWeek": "7 derniers jours",
    "newUsersWeek": "Nouveaux · 7 jours",
    "engagement": "Engagement",
    "mealsToday": "Repas aujourd'hui",
    "workoutsToday": "Entraînements aujourd'hui",
    "waterToday": "Entrées d'eau aujourd'hui",
    "sharedMealsWeek": "Repas partagés · 7 j",
    "aiUsage": "Utilisation IA",
    "coachMsgsToday": "Coach IA · aujourd'hui",
    "weeklyMenusWeek": "Menus hebdo · 7 j",
    "total": "total",
    "recipeImagesCached": "Cache photos de recettes",
    "foodsAiCached": "Cache aliments IA",
    "notifSocial": "Push & communauté",
    "pushSubs": "Abonnés push",
    "notifToday": "Pushs aujourd'hui",
    "chatWeek": "Messages chat · 7 j",
    "upcomingAppts": "RDV à venir",
    "growthTrend": "Tendance de croissance"
  },
  "nutProfile": {
    "title": "Profil",
    "subtitle": "Gère le compte et l'apparence.",
    "accountTitle": "Compte",
    "fullName": "Nom complet",
    "email": "E-mail",
    "emailReadOnly": "L'e-mail ne peut pas être modifié",
    "inviteTitle": "Code d'invitation du cabinet",
    "inviteHelp": "Partage ce code avec les nouveaux clients pour les lier à ton cabinet."
  },
  "builder": {
    "titleField": "Titre",
    "defaultDayLabel": "Journée type",
    "generatedOk": "Plan généré avec l'IA. Tu peux le modifier et l'enregistrer.",
    "aiErrorPrefix": "Erreur IA",
    "savedOk": "Plan enregistré et attribué au client",
    "trainingDayLabel": "Jour d'entraînement",
    "title": "Créateur de plan alimentaire",
    "for": "Pour",
    "savePlan": "Enregistrer le plan",
    "aiTitle": "Générateur IA (GPT-5.2)",
    "aiDesc": "Prérempli un plan selon le profil du client. Modifie ensuite librement.",
    "caloriesTarget": "Calories cibles",
    "preferences": "Préférences / notes",
    "preferencesPh": "ex. sans lactose, plus de poisson, petit-déj sucré",
    "generating": "Génération…",
    "generate": "Générer avec l'IA",
    "clientNotes": "Notes pour le client",
    "mealName": "Nom du repas",
    "mealTime": "Heure",
    "mealDesc": "Description (aliments, portions)",
    "addMeal": "Ajouter un repas",
    "addDay": "Ajouter un jour (ex. entraînement)"
  },
  "apptsNut": {
    "confirmed": "Confirmé",
    "cancelled": "Annulé",
    "updated": "Mis à jour",
    "title": "Rendez-vous",
    "subtitle": "Gère les demandes de réservation de tes clients.",
    "pendingSection": "Demandes en attente",
    "empty": "Rien ici",
    "confirmedSection": "Confirmés",
    "markDone": "Marquer comme terminé",
    "archiveSection": "Archive"
  },
  "myPlan": {
    "translateError": "Traduction échouée",
    "title": "Mon plan",
    "subtitle": "Le plan alimentaire personnalisé de ton nutritionniste.",
    "notLinkedTitle": "Connecte-toi à ton nutritionniste",
    "notLinkedDesc": "Saisis le code d'invitation de ton nutritionniste pour recevoir ton plan personnalisé.",
    "notLinkedHint": "Le code a 6 caractères (ex. ABC123). Si tu ne l'as pas, demande à ton nutritionniste.",
    "empty": "Aucun plan attribué",
    "emptyDesc": "Ton nutritionniste t'en attribuera un bientôt.",
    "translatedBadge": "Traduit",
    "translateOriginal": "Voir l'original",
    "translating": "Traduction…",
    "translateBtn": "Traduire en français"
  },
  "apptsCli": {
    "sentOk": "Demande envoyée ! Le nutritionniste confirmera.",
    "title": "Rendez-vous",
    "subtitle": "Demande une consultation à ton nutritionniste.",
    "noNutTitle": "Lie d'abord un nutritionniste",
    "noNutDesc": "Pour demander une consultation, saisis le code d'invitation de ton nutritionniste sur ta page de profil.",
    "goLinkNut": "Aller au profil",
    "newRequest": "Nouvelle demande",
    "typeLabel": "Type",
    "firstVisit": "Première visite",
    "checkup": "Contrôle",
    "sportsConsult": "Consultation sportive",
    "modalityLabel": "Modalité",
    "inOffice": "Au cabinet",
    "video": "Visioconférence",
    "notesPh": "Notes pour le nutritionniste (optionnel)",
    "sendRequest": "Envoyer la demande",
    "yourBookings": "Tes réservations",
    "empty": "Aucun rendez-vous."
  },
  "chat": {
    "title": "Chat",
    "subtitleClient": "Écris à ton nutritionniste",
    "subtitleNut": "Réponds à tes clients",
    "noClients": "Pas encore de clients",
    "linkNutFirst": "Lie un nutritionniste pour commencer à discuter",
    "selectClient": "Sélectionne un client",
    "noMessages": "Pas encore de messages. Envoie le premier !",
    "messagePh": "Écris un message…"
  }
};

export default fr;
